// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:28:36.002Z
// Property: The Tribute (ID: 5647035332034560)
// Collections: 19 amenities, 13 floorplans (live), 21 photos, 82 POIs, 2 reviews, 4 virtual tours, 7 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5647035332034560",
  "property_external_id": "5056169",
  "property_zillow_url": "https://www.zillow.com/apartments/spring-tx/26325-northgate-crossing/5XhsSW/",
  "property_apartments_url": "https://www.apartments.com/the-tribute-spring-tx/qnc02ty",
  "property_google_business_url": "https://www.google.com/maps/place/The+Tribute/data=!4m2!3m1!1s0x0:0xd44c519d07969b1f?sa=X&ved=2ahUKEwj4xMKb1bySAxW4JUQIHexcHjoQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "5057840441",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-tribute",
  "property_name": "The Tribute",
  "property_website_url": "https://www.liveatthetribute.com/",
  "property_domain": "https://www.liveatthetribute.com/",
  "property_address": "26325 Northgate Crossing Blvd",
  "property_full_address": "26325 Northgate Crossing Blvd, Spring, TX 77373",
  "property_address_1": "26325 Northgate Crossing Blvd",
  "property_address_2": null,
  "property_address_city": "Spring",
  "property_address_state": "TX",
  "property_address_zip_full": "77373-5625",
  "property_address_zip": "77373",
  "property_address_country": "US",
  "property_address_county": "Harris County",
  "property_neighborhood_address": "Northgate Crossing",
  "property_address_latitude": "30.1065509",
  "property_address_longitude": "-95.42897699999999",
  "property_email": "tribute@alapts.com",
  "property_phone": "(281) 651-6644",
  "property_call_tracking_phone": "346-746-7242",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern Spring apartments with room to unwind.</strong> The Tribute pairs polished one-, two-, and three-bedroom homes with resort-style community spaces in Northgate Crossing—compare <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
  "property_long_description": "<p><strong>Modern Spring apartments with resort-style breathing room.</strong> At The Tribute in Northgate Crossing, you get one-, two-, and three-bedroom layouts with polished everyday finishes—quartz countertops, stainless steel appliances, shaker-style cabinetry, subway tile backsplashes, in-home washers and dryers, pantries, crown molding, and private patios or balconies. Beyond your door, two community ponds set a relaxed backdrop for a beach-entry pool, 24-hour fitness center, resident clubhouse, putting green, sand volleyball court, BBQ picnic areas, package lockers, and a bark park; explore more on the <a href=\"/amenities\">amenities</a> page.</p><p><strong>Connected to North Houston’s best routes and recreation.</strong> From Northgate Crossing, you’re near I-45, the Hardy Toll Road, and Grand Parkway for access to Springwoods Village, City Place, The Woodlands, George Bush Intercontinental Airport, and major campuses along the corridor. Weekends can point toward Old Town Spring, Spring Creek Greenway Nature Center, Mercer Arboretum, or shopping and dining around Rayford Road. Compare <a href=\"/floor-plans\">floor plans</a> or see more nearby highlights in the <a href=\"/neighborhood\">neighborhood</a>.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019d02ef-ba8a-76d1-a055-f86049e32db4.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool area with lounge chairs and a waterfall feature.",
    "public_id": "019d02ef-ba8a-76d1-a055-f86049e32db4",
    "storage_key": "property/5647035332034560/019d02ef-ba8a-76d1-a055-f86049e32db4.webp",
    "width": 1240,
    "height": 697
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "248",
  "property_year_built": "2002",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.54838709677419",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $25 / pet\nApplication Approval Fee Starting At $300\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8943836.onlineleasing.realpage.com/",
  "property_resident_portal_url": "https://thetribute.loftliving.com/login",
  "property_apply_now_url": "https://8943836.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e7402-1d1d-76fb-99f7-8d3b90ffc14c.webp",
  "property_primary_logo_media": {
    "alt_text": "The Tribute Apartments logo with Spring, TX text.",
    "public_id": "019e7402-1d1d-76fb-99f7-8d3b90ffc14c",
    "storage_key": "property/5647035332034560/019e7402-1d1d-76fb-99f7-8d3b90ffc14c.webp",
    "width": 1755,
    "height": 372
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e7402-5f9f-7359-b859-68dc3b05ba6e.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Tribute Apartments Spring TX logo",
    "public_id": "019e7402-5f9f-7359-b859-68dc3b05ba6e",
    "storage_key": "property/5647035332034560/019e7402-5f9f-7359-b859-68dc3b05ba6e.webp",
    "width": 1561,
    "height": 415
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e7401-c4af-7104-8557-560f62639904.webp",
  "property_icon_media": {
    "alt_text": "The Tribute Apartments logo",
    "public_id": "019e7401-c4af-7104-8557-560f62639904",
    "storage_key": "property/5647035332034560/019e7401-c4af-7104-8557-560f62639904.webp",
    "width": 1277,
    "height": 1277
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e7401-c4af-7104-8557-560f62639904.webp",
  "property_fav_icon_media": {
    "alt_text": "The Tribute Apartments logo",
    "public_id": "019e7401-c4af-7104-8557-560f62639904",
    "storage_key": "property/5647035332034560/019e7401-c4af-7104-8557-560f62639904.webp",
    "width": 1277,
    "height": 1277
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e7402-1cac-7158-a432-f42fa6bdaf1f.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Tribute Apartments logo with Spring, TX.",
    "public_id": "019e7402-1cac-7158-a432-f42fa6bdaf1f",
    "storage_key": "property/5647035332034560/019e7402-1cac-7158-a432-f42fa6bdaf1f.webp",
    "width": 1755,
    "height": 372
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e7402-1c91-74d2-a345-c691ea7c4019.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Tribute Apartments logo with Spring, TX.",
    "public_id": "019e7402-1c91-74d2-a345-c691ea7c4019",
    "storage_key": "property/5647035332034560/019e7402-1c91-74d2-a345-c691ea7c4019.webp",
    "width": 1755,
    "height": 372
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#0b3b4a",
  "property_secondary_color": "#b46a28",
  "property_font_color": "#2e2a25",
  "property_color_4": "#9da2a3",
  "property_color_3": "#decaa3",
  "property_color_5": "#ffffff",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "599 - 1234",
  "property_sqft_min": "599",
  "property_sqft_max": "1234",
  "property_price_range": "1119 - 1970",
  "property_price_min": "1119",
  "property_price_max": "1970",
  "property_available_units": 16,
  "property_facebook_url": "https://www.facebook.com/TheTributeApartments",
  "property_instagram_url": "https://www.instagram.com/thetributeapartments",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJPRwWvLE1R4YRH5uWB51RTNQ",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-tribute-spring",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Downtime feels effortless at The Tribute.</strong> Spend sunny hours by two scenic ponds, a gazebo, beach-entry pool, BBQ picnic areas, putting green, and sand volleyball court. Indoors, a 24-hour fitness center, resident clubhouse, package lockers, and online services keep daily routines simple, while quartz countertops, stainless steel appliances, in-home laundry, and select private patios or balconies add polish at home.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to choose.</strong> Explore one-, two-, and three-bedroom apartments in Spring, TX, with layouts ranging from sleek and simple to more spacious designs with extra bedrooms and baths. Inside, polished finishes like quartz countertops, stainless steel appliances, built-in microwaves, kitchen pantries, in-home washers and dryers, crown molding, and private patios or balconies bring everyday function into focus.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview life at The Tribute.</strong> Flip through bright interiors with quartz countertops, stainless steel appliances, subway tile, shaker-style cabinetry, crown molding, and patios or balconies. Then step outside through the gallery to pond views, a tropical-style pool, putting green, picnic grills, and green courtyard spaces made for easy Spring downtime.</p>",
  "property_home_neighborhood_blurb": "<p><strong>North Houston connections, Spring character.</strong> At The Tribute in Northgate Crossing, Hardy Toll Road, Grand Parkway, and I-45 keep CityPlace, Springwoods Village, The Woodlands, and downtown Houston within easy reach. Close by, find everyday essentials, local coffee, and the historic storefronts, restaurants, and small-shop finds of Old Town Spring. For outdoor time, Dennis Johnston Park and the Spring Creek Greenway add trails and wooded scenery to the map.</p>",
  "property_home_reviews_blurb": "<p><strong>Real reviews, real confidence.</strong> Residents point to a quiet community feel, clean and well-kept apartments, responsive maintenance, and a team known for friendly, attentive service. From “the best apartments I’ve ever lived in” to “the staff is phenomenal,” the feedback highlights the everyday details that make The Tribute stand out on Northgate Crossing.</p>",
  "property_neighborhood_blurb": "<p><strong>Set your map to easy North Houston access.</strong> From The Tribute in Northgate Crossing, you’re close to the Hardy Toll Road and Grand Parkway, with I-45 nearby for trips toward CityPlace, Springwoods Village, The Woodlands, or downtown Houston. Around the neighborhood, everyday stops stay simple with grocery, coffee, and services near Northgate Crossing, while Old Town Spring brings a different pace with historic storefronts, local restaurants, Wunsche Bros., tea rooms, and small-shop finds.</p><p>When you want fresh air, Dennis Johnston Park and the Spring Creek Greenway put trails and wooded scenery within reach, and the METRO Spring Park &amp; Ride offers another option for downtown commutes. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the location fits your routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity spaces that make downtime easy.</strong> Start by the water: a gazebo overlooking two ponds, a beach-entry pool, BBQ picnic areas, a putting green, and sand volleyball give you plenty of ways to enjoy the community outdoors. Inside, the 24-hour fitness center, resident clubhouse, package lockers, controlled-access entry, and online resident services help keep everyday routines moving.</p><p>Your apartment adds the same polished feel with quartz countertops, stainless steel appliances, shaker-style cabinetry, subway tile, in-home laundry, and a private patio or balcony in select layouts. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how The Tribute’s amenities come together.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make The Tribute home?</strong><br>Start your online application for a one-, two-, or three-bedroom apartment with polished finishes, in-home laundry, and private outdoor space—plus resort-style community breathing room in Northgate Crossing.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong> Contact The Tribute leasing team to learn more about our one-, two-, and three-bedroom Spring apartments, polished in-home finishes, and relaxed Northgate Crossing setting. Reach out for details, directions, or help planning your next visit.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life at The Tribute?</strong> Start here for quick answers on the community, leasing, apartment features, and everyday details at our modern Spring apartments in Northgate Crossing. If you don’t see what you need, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the layout that fits the way you move through your day.</strong> The Tribute offers one-, two-, and three-bedroom apartment floor plans in Spring, with options that range from streamlined and easy-to-maintain to more spacious layouts with added bedrooms and baths.</p><p>Inside, look for everyday upgrades that make each plan feel polished: quartz countertops, stainless steel appliances, built-in microwaves, kitchen pantries, in-home washers and dryers, crown molding, and private patios or balconies. Compare current pricing and availability, then explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how your favorite layout comes together in person.</p>",
  "property_gallery_blurb": "<p><strong>See The Tribute before you visit.</strong> Browse photos that move from sunlit apartment interiors to outdoor spaces shaped for easy downtime in Spring. Look for kitchens with quartz counters, stainless steel appliances, subway tile, and shaker-style cabinetry, plus living areas with crown molding and a private patio or balcony just beyond the glass.</p><p>The gallery also captures the moments that give the community its relaxed character: water views from the ponds, a tropical-style pool, the putting green, picnic grills, and green courtyard corners. When a photo sparks a favorite detail, compare <a href=\"/floor-plans\">one-, two-, and three-bedroom layouts</a>, explore more <a href=\"/amenities\">amenities</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Find your place in Northgate Crossing.</strong> Use the interactive map to explore available <a href=\"/floor-plans\">one-, two-, and three-bedroom apartments</a>, then zoom out to see how The Tribute connects to major North Houston routes, nearby recreation, shopping, dining, and everyday conveniences.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with room for daily rituals.</strong> At The Tribute, your cat can claim a sunny window, your dog has an on-site bark park for easy energy burns, and you can keep walks simple with courtyards, pond views, and green community spaces right outside your door.</p><p>Back home, in-home washers and dryers help with muddy-paw moments, while select patios or balconies add a little fresh-air space between outings. When you want a bigger adventure, Spring offers nearby dog-park options like Pundt Park, and The Tribute keeps everyday pet life close to the amenities you already use. Explore more <a href=\"/amenities\">community features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the bark park in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share the breathing room.</strong> Love the polished finishes, private patio or balcony, two-pond backdrop, and resort-style spaces at The Tribute? Invite a friend to experience modern Spring living in Northgate Crossing—and send them our way with the referral form below.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Tribute.</strong> Manage everyday apartment living in one convenient place—pay rent, submit maintenance requests, and update your account, then get back to enjoying modern Spring comfort with polished finishes and resort-style breathing room.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback, everyday confidence.</strong> On this page, you’ll find reviews from residents who highlight the details that shape daily life at The Tribute: a quiet community feel, clean and well-maintained apartments, and a team that listens.</p><p>Residents frequently call out responsive maintenance, friendly service, and management that shows care when it matters. One reviewer described it as “the best apartments I’ve ever lived in,” while another shared that “the staff is phenomenal!” You’ll also see mentions of peaceful surroundings, resident activities, and a Northgate Crossing setting that continues to grow.</p>",
  "property_created_at": "1752256386692",
  "property_scheduletour_blurb": "<p><strong>See the breathing room in person.</strong> Tour The Tribute and get a closer look at modern one-, two-, and three-bedroom apartments with quartz countertops, stainless steel appliances, in-home washers and dryers, and private patios or balconies—then step outside to the relaxed, resort-style setting that makes Northgate Crossing feel easy to come home to.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br> The Tribute leasing team will follow up soon. In the meantime, picture polished one-, two-, and three-bedroom apartments with quartz countertops, stainless steel appliances, in-home washers and dryers, and private patios or balconies—plus resort-style breathing room in Northgate Crossing.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through The Tribute before you arrive.</strong> Start with the Community and Clubhouse virtual tours, then step inside the one-bedroom and two-bedroom apartment tours to see how the spaces flow from room to room. Look for bright windows, crown molding, wood-look flooring, quartz countertops, stainless steel appliances, shaker-style cabinetry, and the kind of kitchen and storage details that are easier to understand in motion than in photos.</p><p>Use the tours to compare layouts from anywhere, pause on finishes that matter to you, and picture how everyday routines feel at this Spring apartment community. When a walkthrough clicks, browse <a href=\"/floor-plans\">current floor plans</a> or <a href=\"/schedule-a-tour\">schedule an in-person tour</a> to see The Tribute up close.</p>",
  "property_copyright": "2025 All Rights Reserved. The Tribute",
  "property_seo_title_home": "The Tribute | Apartments in Spring, TX",
  "property_seo_description_home": "Welcome to The Tribute in Spring, TX—where modern living meets unparalleled comfort. Choose from chic one, two, or three-bedroom floor plans and immerse yourself in a vibrant community filled with amenities. Enjoy socializing at the clubhouse, unwind at the pool, or stay active in the fitness center or volleyball court. With perks like a dog park, LUXER package lockers, and convenient online resident services, your ideal lifestyle awaits. Embrace luxury living surrounded by beautiful courtyards and hardwood flooring. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Spring, TX",
  "property_seo_description_floorplans": "Unleash your lifestyle at The Tribute in Spring, TX! With a range of thoughtfully designed floor plans, from cozy one-bedroom retreats to spacious three-bedroom havens, we have the ideal space to suit your needs. Dive into a world of comfort and style—browse our available apartment homes now to find your perfect match!",
  "property_seo_title_amenities": "Amenities | Spring, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience elevated living at The Tribute in Spring, TX. Our thoughtfully designed one, two, and three-bedroom apartments come with luxurious amenities, including a refreshing pool, modern fitness center, and inviting dog park. Enjoy added convenience with LUXER package lockers, online resident services, and access gates. Whether you're lounging in our stylish clubhouse or hosting a BBQ in the courtyard, every corner invites relaxation and connection. Dive into a lifestyle that blends comfort with community—where your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Spring, TX",
  "property_seo_description_gallery": "Capture the essence of upscale living at The Tribute in Spring, TX. Browse through our stunning photo gallery showcasing stylish one, two, and three-bedroom floor plans complete with modern amenities like a serene pool view, dog park, and a vibrant clubhouse. With a fitness center, volleyball court, and community green space, our vibrant lifestyle awaits you. Picture yourself enjoying life to the fullest—join our welcoming community today!",
  "property_seo_title_virtualtours": "Virtual Tours | The Tribute Apartments",
  "property_seo_description_virtualtours": "Immerse yourself in the vibrant lifestyle at The Tribute in Spring, TX. With thoughtfully designed one, two, and three-bedroom floor plans, our virtual tour showcases stunning spaces tailored to your needs. Experience exceptional amenities and community vibes – take your virtual tour today and envision your new home!",
  "property_seo_title_interactivemap": "Interactive Map | The Tribute Apartments",
  "property_seo_description_interactivemap": "Unveil your perfect home at The Tribute in Spring, TX, where comfort meets convenience. Choose from one, two, or three-bedroom floor plans and enjoy exceptional amenities like a resort-style pool, dog park, and a state-of-the-art fitness center. With added perks like LUXER package lockers and online resident services, modern living has never been easier. Dive into our interactive community map to find your ideal apartment, view pricing, and embark on your new adventure today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Spring, TX",
  "property_seo_description_neighborhood": "Experience the vibrant community surrounding The Tribute in Spring, TX! From charming local shops to scenic parks, uncover the hidden gems that make this neighborhood a place to call home. With one, two, and three-bedroom floor plans available, you'll find your perfect retreat just steps from your favorite dining and entertainment options. Join us and enrich your lifestyle—your ideal neighborhood awaits!",
  "property_seo_title_contact": "Contact Us | The Tribute",
  "property_seo_description_contact": "Experience the charm of The Tribute in Spring, TX—your ideal home awaits! With thoughtfully designed one, two, and three-bedroom floor plans, we offer a lifestyle tailored to you. Whether you're seeking spacious living or cozy comforts, we have options that fit every need. Have questions? Contact our leasing team today and embark on your journey to comfortable living!",
  "property_seo_title_faqs": "FAQs | Apartments in Spring, TX",
  "property_seo_description_faqs": "Uncover essential insights about The Tribute in Spring, TX! Delve into our FAQs to learn about our spacious one, two, and three-bedroom floor plans, luxurious amenities like our state-of-the-art fitness center and inviting pool, and convenient resident services designed for your comfort. Whether you’re curious about our dog park or community BBQ area, we’ve got the answers you need! ",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Spring, TX",
  "property_seo_description_reviews": "\"Experience life at The Tribute in Spring, TX, where our vibrant community offers a range of one, two, and three-bedroom floor plans tailored to your lifestyle. Enjoy top-tier amenities like a refreshing pool, modern fitness center, and a welcoming clubhouse. Cherish outdoor moments at our dog park or volleyball court, and take advantage of the convenience of LUXER Package Lockers and online resident services. Don’t just take our word for it—see what our residents have to say about calling The Tribute home!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Spring, TX",
  "property_seo_description_applynow": "\"Elevate your lifestyle at The Tribute in Spring, TX. Choose from spacious one to three-bedroom floor plans and enjoy premium amenities like a refreshing pool, a modern fitness center, and a pet-friendly dog park. With online resident services and luxury features such as hardwood flooring and a stylish tile backsplash, your dream home awaits. Apply now and secure your perfect retreat!\"",
  "property_seo_title_residentaccess": "Resident Access | The Tribute",
  "property_seo_description_residentaccess": "\"Welcome to The Tribute in Spring, TX! Seamlessly manage your life at home with our resident portal. Log in to pay rent, request maintenance, and unlock the community perks that make living here special. Your convenience, our priority!\"",
  "property_seo_title_referafriend": "Refer A Friend | The Tribute",
  "property_seo_description_referafriend": "\"Share the love for The Tribute in Spring, TX! Refer a friend and help them discover the perks of living in a vibrant community where great friends become great neighbors. Join us in creating a home that thrives on connection!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | The Tribute",
  "property_seo_description_scheduletour": "\"Step into a world of elegance at The Tribute in Spring, TX. Schedule a personalized tour today and experience the perfect blend of comfort and luxury living, where your new home awaits amidst lush landscapes and vibrant community life.\"",
  "property_seo_title_privacy": "Privacy Policy | The Tribute",
  "property_seo_description_privacy": "\"At The Tribute in Spring, TX, your privacy is our priority. Uncover how we safeguard your personal information while providing a seamless apartment living experience. View our privacy policy to learn more.\"",
  "property_seo_title_accessibility": "Website Accessibility | The Tribute",
  "property_seo_description_accessibility": "\"At The Tribute in Spring, TX, we celebrate inclusivity for all with our comprehensive Accessibility Statement. Discover our commitment to accessible living and how we strive to create a welcoming environment for every resident. Join us in making every experience seamless and enjoyable!\"",
  "property_seo_title_sitemap": "Sitemap | The Tribute",
  "property_seo_description_sitemap": "Uncover the seamless layout of The Tribute in scenic Spring, TX. Navigate our sitemap to find your ideal apartment home, explore community amenities, and connect with the vibrant lifestyle waiting for you. Your next chapter starts here!",
  "property_seo_title_thankyou": "Thank You | The Tribute",
  "property_seo_description_thankyou": "Thank you for reaching out to The Tribute in Spring, TX! Your inquiry is in good hands, and our team will connect with you soon to share the vibrant lifestyle awaiting you. Exciting adventures and cozy comforts are just around the corner! ",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320860",
  "amenities": [
    {
      "id": "custom_a54eb637-66a6-4430-9ece-e9bfa805d777",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Subway Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8d6d7cd9-8323-45d7-ad2d-6402ef142641",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b24fffae-3690-4d53-bb52-ba4503e33529",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000000666",
      "title": "Pantry Closets",
      "amount": "0.0000",
      "description": "Kitchen Pantry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cbde7171-2ae4-4c9c-9227-16b6d8144963",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000000676",
      "title": "Sink",
      "amount": "0.0000",
      "description": "Undermount Sink w/ Gooseneck Sink",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f4ab697f-96cf-42d8-a4f6-c157a96918e2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000000606",
      "title": "Built-In Microwave",
      "amount": "0.0000",
      "description": "Built-In Microwaves",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a5c5c0ec-a81e-4959-8998-f83acc1ca0c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Shaker-Style Cabinetry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ab9a734e-b723-40c1-8cb1-2c5f6efdea28",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Quartz Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bc5386e2-4274-40cd-a784-3b78b52a880c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_130b57ed-1827-4510-b679-e01f9b604a73",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Style Swimming Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_215e5e00-ede6-4549-b4ad-322b83809441",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000000614",
      "title": "Clubhouse",
      "amount": "0.0000",
      "description": "Resident Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_49db229b-9573-43a6-ab37-a6f72f7adfe1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0268b7af-25ac-4f54-858e-2294a4086773",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_84d0f1cc-7406-46d4-9806-f4e6d7e92b21",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000000701",
      "title": "Volleyball Court",
      "amount": "0.0000",
      "description": "Sand Volleyball Court",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_81cb5020-1ae6-43a0-9278-a934c5820894",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c6a52eaa-d092-487a-9151-a9af2962086c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000001279",
      "title": "BBQ",
      "amount": "0.0000",
      "description": "Picnic Areas w/ BBQ Grills",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d104de23-3faf-4229-98f4-331f6608fafc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Gates",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1b760c47-5186-4f04-8004-15d4c1dd215f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000002256",
      "title": "Community Green Space",
      "amount": "0.0000",
      "description": "Putting Green",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c87542d7-e6e4-42d0-b7e4-6995fc7b26c2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0013b765-b77f-4055-bf0f-bbe6de58a368",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_4244ddde-f956-4830-8a88-b9a6f24b7e09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-baae-75fa-9944-90bb1eff23ad.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "019e8a08-baae-75fa-9944-90bb1eff23ad",
        "storage_key": "property/5647035332034560/019e8a08-baae-75fa-9944-90bb1eff23ad.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, ample cabinet space, and sleek countertops, perfect for culinary creations.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5c8c0790-d058-47fd-beba-07085108c166",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-b1cb-743f-af9f-a8a8dc1675fe.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with high-backed sofas and small tables.",
        "public_id": "019e8a08-b1cb-743f-af9f-a8a8dc1675fe",
        "storage_key": "property/5647035332034560/019e8a08-b1cb-743f-af9f-a8a8dc1675fe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting seating area, perfect for socializing or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Comfortable seating area with high-backed sofas and small tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b7a3a98-185a-4127-8c3d-1eb968ad7dd6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-b197-778f-84db-ff37ee2e3501.webp",
      "image_media": {
        "alt_text": "Cozy corner with two leather chairs, decorative pillows, and a side table with a lamp.",
        "public_id": "019e8a08-b197-778f-84db-ff37ee2e3501",
        "storage_key": "property/5647035332034560/019e8a08-b197-778f-84db-ff37ee2e3501.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax and unwind in this inviting corner, perfect for reading or enjoying a quiet moment. Features comfortable seating and stylish decor.",
      "link": "",
      "alt_text": "Cozy corner with two leather chairs, decorative pillows, and a side table with a lamp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_50328e41-018a-4eb1-b0d3-e4a50b11dfc7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-ae5f-762e-8826-8dfa43ea520c.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a queen-sized bed featuring navy blue bedding and a large abstract artwork above.",
        "public_id": "019e8a08-ae5f-762e-8826-8dfa43ea520c",
        "storage_key": "property/5647035332034560/019e8a08-ae5f-762e-8826-8dfa43ea520c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, complete with a plush queen bed and stylish decor.",
      "link": "",
      "alt_text": "A cozy bedroom with a queen-sized bed featuring navy blue bedding and a large abstract artwork above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_059dabbb-8863-456f-b449-8ea5a3cb5f36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-ac3a-717b-915c-421edf4c8a34.webp",
      "image_media": {
        "alt_text": "Walk-in closet with shelves and hanging space.",
        "public_id": "019e8a08-ac3a-717b-915c-421edf4c8a34",
        "storage_key": "property/5647035332034560/019e8a08-ac3a-717b-915c-421edf4c8a34.webp",
        "width": 2049,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and hanging space for all your storage needs.",
      "link": "",
      "alt_text": "Walk-in closet with shelves and hanging space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dd64ec31-217f-4602-a141-9e0729132a6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-a70e-7368-af03-789c47792a83.webp",
      "image_media": {
        "alt_text": "A desk with a laptop and chair in a home office area.",
        "public_id": "019e8a08-a70e-7368-af03-789c47792a83",
        "storage_key": "property/5647035332034560/019e8a08-a70e-7368-af03-789c47792a83.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A stylish home office setup with a modern desk, laptop, and chair, perfect for remote work or studying. Features decorative elements and a photo display wall.",
      "link": "",
      "alt_text": "A desk with a laptop and chair in a home office area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ddb16d3c-6caf-4680-bdab-737b31164b86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-a932-77b0-9fa8-4b48f1902049.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, coffee maker, and dining area visible through doorway.",
        "public_id": "019e8a08-a932-77b0-9fa8-4b48f1902049",
        "storage_key": "property/5647035332034560/019e8a08-a932-77b0-9fa8-4b48f1902049.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover a stylish and functional kitchen space, complete with modern appliances and a view into a cozy dining area. Perfect for preparing meals and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, coffee maker, and dining area visible through doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d3ec477e-a9ff-401b-bef6-00b305ac986e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-a7a5-75df-805f-488a6ad4a0bb.webp",
      "image_media": {
        "alt_text": "Elegant community lounge with a stone fireplace, comfortable seating, and modern decor.",
        "public_id": "019e8a08-a7a5-75df-805f-488a6ad4a0bb",
        "storage_key": "property/5647035332034560/019e8a08-a7a5-75df-805f-488a6ad4a0bb.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring a cozy stone fireplace and ample seating for residents to socialize or relax.",
      "link": "",
      "alt_text": "Elegant community lounge with a stone fireplace, comfortable seating, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1735eada-7ff1-4a7c-b99c-fc40407698e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-a34c-760e-a6d7-f43d70539ba8.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs, outdoor kitchen, and water feature.",
        "public_id": "019e8a08-a34c-760e-a6d7-f43d70539ba8",
        "storage_key": "property/5647035332034560/019e8a08-a34c-760e-a6d7-f43d70539ba8.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool, complete with comfortable lounge chairs, an outdoor kitchen with grills, and a beautiful cascading water feature. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs, outdoor kitchen, and water feature.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3340c880-e410-4eef-921d-39d42f941c39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-a120-7478-92ba-fb9afd6c2cad.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, silver fixtures, and wood-look flooring.",
        "public_id": "019e8a08-a120-7478-92ba-fb9afd6c2cad",
        "storage_key": "property/5647035332034560/019e8a08-a120-7478-92ba-fb9afd6c2cad.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy a clean and spacious bathroom featuring a double vanity, ample storage, and a walk-in shower with a stylish shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, silver fixtures, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_709edb7b-3982-40fd-b46d-6d08709174f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-a3c3-7628-8497-9f3e8c49cd2b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019e8a08-a3c3-7628-8497-9f3e8c49cd2b",
        "storage_key": "property/5647035332034560/019e8a08-a3c3-7628-8497-9f3e8c49cd2b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Discover a chef-inspired kitchen featuring stainless steel appliances, ample cabinet space, and elegant countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_052b487d-5930-4448-bbfc-8146660e3de2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-8a00-7330-80e6-c88d5e329418.webp",
      "image_media": {
        "alt_text": "Apartment patio with seating and a topiary dog.",
        "public_id": "019e8a08-8a00-7330-80e6-c88d5e329418",
        "storage_key": "property/5647035332034560/019e8a08-8a00-7330-80e6-c88d5e329418.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy your morning coffee or evening relaxation on your private apartment patio, complete with comfortable seating and charming decor.",
      "link": "",
      "alt_text": "Apartment patio with seating and a topiary dog.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a2a8eb4f-51f3-4ce9-a704-848191f2ea1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-8909-763b-ae91-a01241524031.webp",
      "image_media": {
        "alt_text": "Treadmills, elliptical, and stationary bike in a well-lit gym with large windows and TVs.",
        "public_id": "019e8a08-8909-763b-ae91-a01241524031",
        "storage_key": "property/5647035332034560/019e8a08-8909-763b-ae91-a01241524031.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring treadmills, ellipticals, and stationary bikes, all equipped with personal entertainment screens.",
      "link": "",
      "alt_text": "Treadmills, elliptical, and stationary bike in a well-lit gym with large windows and TVs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2b966d1f-9676-4e2f-92e3-52f94ce1d535",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-8a87-7508-a3c4-9309e14aebc7.webp",
      "image_media": {
        "alt_text": "Laundry room with washer and dryer and towels hanging on the wall.",
        "public_id": "019e8a08-8a87-7508-a3c4-9309e14aebc7",
        "storage_key": "property/5647035332034560/019e8a08-8a87-7508-a3c4-9309e14aebc7.webp",
        "width": 2049,
        "height": 3072
      },
      "title": "Apartment",
      "description": "In-unit laundry facilities include a washer, dryer, and convenient towel storage.",
      "link": "",
      "alt_text": "Laundry room with washer and dryer and towels hanging on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_329f863c-ad77-4cee-bd22-a5446c1fa335",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-8ad1-727c-9d4e-e62910d61bd6.webp",
      "image_media": {
        "alt_text": "Dining area with a round table, four chairs, and a bookshelf.",
        "public_id": "019e8a08-8ad1-727c-9d4e-e62910d61bd6",
        "storage_key": "property/5647035332034560/019e8a08-8ad1-727c-9d4e-e62910d61bd6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy meals with friends and family in this elegant dining area, featuring a stylish round table, comfortable seating, and convenient shelving for your books and decor.",
      "link": "",
      "alt_text": "Dining area with a round table, four chairs, and a bookshelf.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b0d1d57a-4612-4086-a826-29e664e39c6e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-8ae3-71c7-8848-3b7879e9485a.webp",
      "image_media": {
        "alt_text": "Well-equipped gym with treadmills, ellipticals, weight bench, and dumbbell rack.",
        "public_id": "019e8a08-8ae3-71c7-8848-3b7879e9485a",
        "storage_key": "property/5647035332034560/019e8a08-8ae3-71c7-8848-3b7879e9485a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring cardio machines and free weights.",
      "link": "",
      "alt_text": "Well-equipped gym with treadmills, ellipticals, weight bench, and dumbbell rack.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7e680c21-b56a-49c7-8185-d2c414b2337c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-88d3-76bd-b576-1889a53573e9.webp",
      "image_media": {
        "alt_text": "Package lockers at The Tribute apartment community.",
        "public_id": "019e8a08-88d3-76bd-b576-1889a53573e9",
        "storage_key": "property/5647035332034560/019e8a08-88d3-76bd-b576-1889a53573e9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Secure package lockers available for residents at The Tribute apartment community, offering convenient package delivery and pickup.",
      "link": "",
      "alt_text": "Package lockers at The Tribute apartment community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ecf5106b-6864-47a2-bf08-71464b3df69a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-8930-7454-8686-cc0a2735f57d.webp",
      "image_media": {
        "alt_text": "Cozy corner of a bedroom with two accent chairs, a side table with a lamp, and a TV mounted on the wall above a dresser.",
        "public_id": "019e8a08-8930-7454-8686-cc0a2735f57d",
        "storage_key": "property/5647035332034560/019e8a08-8930-7454-8686-cc0a2735f57d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax and unwind in your stylish bedroom, complete with comfortable seating, a TV for entertainment, and ample storage space.",
      "link": "",
      "alt_text": "Cozy corner of a bedroom with two accent chairs, a side table with a lamp, and a TV mounted on the wall above a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b23cac5e-7b12-4cd7-bbd6-dd45531c07ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-893d-7609-8f11-ebd8d06618ff.webp",
      "image_media": {
        "alt_text": "Living room with white couch, blue ottoman, and accent chair.",
        "public_id": "019e8a08-893d-7609-8f11-ebd8d06618ff",
        "storage_key": "property/5647035332034560/019e8a08-893d-7609-8f11-ebd8d06618ff.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable white couch, a vibrant blue ottoman, and a unique accent chair, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with white couch, blue ottoman, and accent chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9c377845-a261-44bf-af76-a1508accc3f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-8874-7057-889c-4c5f3ac06a7d.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, nightstand, and dresser.",
        "public_id": "019e8a08-8874-7057-889c-4c5f3ac06a7d",
        "storage_key": "property/5647035332034560/019e8a08-8874-7057-889c-4c5f3ac06a7d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a queen-size bed, ample storage, and stylish decor.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, nightstand, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_32f1d263-3fc9-44c0-a258-81def311a888",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019e8a08-8811-737f-9e85-75b4962c5e61.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with tanning ledge and cascading water feature, surrounded by lounge chairs and umbrellas.",
        "public_id": "019e8a08-8811-737f-9e85-75b4962c5e61",
        "storage_key": "property/5647035332034560/019e8a08-8811-737f-9e85-75b4962c5e61.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, featuring a tanning ledge and a beautiful cascading water feature. Enjoy the sunshine on our comfortable lounge chairs.",
      "link": "",
      "alt_text": "Resort-style swimming pool with tanning ledge and cascading water feature, surrounded by lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_39c8303c5605975184cfd8a3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "CorkScrew BBQ",
      "poi_type": "Restaurants",
      "poi_address": "26608 Keith St, Spring, TX 77373, USA",
      "poi_short_description": "Trailer offering wood-smoked BBQ staples to diners at semicovered picnic tables (BYO).",
      "poi_long_description": "Trailer offering wood-smoked BBQ staples to diners at semicovered picnic tables (BYO).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-0e1e-7628-acf8-ee774723b8c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-0e1e-7628-acf8-ee774723b8c3",
        "storage_key": "property/5647035332034560/019f14ea-0e1e-7628-acf8-ee774723b8c3.webp",
        "width": 1280,
        "height": 871
      },
      "poi_business_url": "http://www.corkscrewbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8452398059256173365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corkscrew-bbq",
      "poi_latitude": "30.0806962",
      "poi_longitude": "-95.4199226",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-330-2178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fabb4dbf5b98",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRfY7ATs0R4YRNVMqjkDzTHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_07e6a24f4f7c071e87ea872b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Tri-State Bagels",
      "poi_type": "Restaurants",
      "poi_address": "708 Spring Cypress Rd Ste AM, Spring, TX 77373, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ec-fa2d-7719-976b-ae6262228a9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-fa2d-7719-976b-ae6262228a9f",
        "storage_key": "property/5647035332034560/019f14ec-fa2d-7719-976b-ae6262228a9f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://blacksheepl8v8d.toast.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1007717673293763994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tri-state-bagels",
      "poi_latitude": "30.0794925",
      "poi_longitude": "-95.4251542",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-353-2329",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fabb4dbf5b98",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF0RyaQA1R4YRmtWOfuIh_A0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "ec_970e8b84545a67e01bbabf93",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "BLACK SHEEP L8V8D",
      "poi_type": "Restaurants",
      "poi_address": "708 Spring Cypress Rd, Spring, TX 77373, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-020b-767c-903e-9ba0a6669a29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-020b-767c-903e-9ba0a6669a29",
        "storage_key": "property/5647035332034560/019f14ed-020b-767c-903e-9ba0a6669a29.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://blacksheepl8v8d.toast.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4856838562877349842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-sheep-l8v8d",
      "poi_latitude": "30.0794925",
      "poi_longitude": "-95.4251542",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 657-793-1572",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fabb4dbf5b98",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPxoOeRA1R4YR0h-5t_D0ZkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_a266266506cbebcfbbff87ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "JAX",
      "poi_type": "Restaurants",
      "poi_address": "1206 Spring Cypress Rd, Spring, TX 77373, USA",
      "poi_short_description": "Casual hamburger eatery offering milkshakes and fries as well as burgers made from fresh beef, plus chicken sandwiches and Philly cheesesteaks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ec-ff94-713a-a094-b20df33dd54a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-ff94-713a-a094-b20df33dd54a",
        "storage_key": "property/5647035332034560/019f14ec-ff94-713a-a094-b20df33dd54a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jaxburgers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3781719519018767924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jax",
      "poi_latitude": "30.0765477",
      "poi_longitude": "-95.432496",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-907-6018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fabb4dbf5b98",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiQC3Ohw1R4YRNFZGu91dezQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_c9d30b5f2c9bc83aef1289f8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Wunsche Bros. Cafe & Saloon",
      "poi_type": "Restaurants",
      "poi_address": "103 Midway St, Spring, TX 77373, USA",
      "poi_short_description": "This allegedly haunted eatery from 1902 offers American fare with a Texas accent & a full bar.",
      "poi_long_description": "This allegedly haunted eatery from 1902 offers American fare with a Texas accent & a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-00d9-71a9-ad38-b31aaa9bea80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-00d9-71a9-ad38-b31aaa9bea80",
        "storage_key": "property/5647035332034560/019f14ed-00d9-71a9-ad38-b31aaa9bea80.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://wunschebros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1163036740643149525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wunsche-bros-cafe--saloon",
      "poi_latitude": "30.0791427",
      "poi_longitude": "-95.4175584",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-350-2233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fabb4dbf5b98",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPQF1VRI1R4YR1VbD6sDvIxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_d36c6d0c6b80b8f0b0274a1e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Lynn's Table",
      "poi_type": "Restaurants",
      "poi_address": "307 Gentry St, Spring, TX 77373, USA",
      "poi_short_description": "Fudge, homemade ice cream & American lunch standards served in a quaint, homey cafe.",
      "poi_long_description": "Fudge, homemade ice cream & American lunch standards served in a quaint, homey cafe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ec-f629-700a-94e0-4b490653bff9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-f629-700a-94e0-4b490653bff9",
        "storage_key": "property/5647035332034560/019f14ec-f629-700a-94e0-4b490653bff9.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://lynnstable.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17561407402880082887&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lynns-table",
      "poi_latitude": "30.0784003",
      "poi_longitude": "-95.4196569",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-353-9229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fabb4dbf5b98",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmY5l2hM1R4YRxyOVFP2mtvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_e93af25c986c2a3a18b776da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Loose Caboose",
      "poi_type": "Restaurants",
      "poi_address": "26403 Preston Ave, Spring, TX 77373, USA",
      "poi_short_description": "Offbeat neighborhood joint offering burgers, BBQ & other street foods, plus beer & outdoor seating.",
      "poi_long_description": "Offbeat neighborhood joint offering burgers, BBQ & other street foods, plus beer & outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-00da-768d-9e8e-0f96e9051ec7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-00da-768d-9e8e-0f96e9051ec7",
        "storage_key": "property/5647035332034560/019f14ed-00da-768d-9e8e-0f96e9051ec7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.theloosecaboosebbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=551679813252134622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loose-caboose",
      "poi_latitude": "30.0788587",
      "poi_longitude": "-95.4186321",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-288-1733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fabb4dbf5b98",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0TkWtBM1R4YR3ralAt71pwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_47d5afc72e1c419a5f910c18",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Prohibition Texas",
      "poi_type": "Restaurants",
      "poi_address": "118 Midway St, Spring, TX 77373, USA",
      "poi_short_description": "Woodsy locale with a Prohibition theme offering unique cocktails, cigars, spirits & casual bar fare.",
      "poi_long_description": "Woodsy locale with a Prohibition theme offering unique cocktails, cigars, spirits & casual bar fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ec-fb57-77ca-9ace-306ff916bb6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-fb57-77ca-9ace-306ff916bb6f",
        "storage_key": "property/5647035332034560/019f14ec-fb57-77ca-9ace-306ff916bb6f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.prohibitiontexas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14653938860348750799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prohibition-texas",
      "poi_latitude": "30.079183",
      "poi_longitude": "-95.4182327",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 832-585-1438",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-4b38-75a7-9015-77348fa3af17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4b38-75a7-9015-77348fa3af17",
        "storage_key": "property/5647035332034560/019f14ed-4b38-75a7-9015-77348fa3af17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__9rsxM1R4YRzzth68A_Xcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_42d7fabd09b4a4a50726965f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "El Palenque",
      "poi_type": "Restaurants",
      "poi_address": "1485 Spring Cypress Rd, Spring, TX 77373, USA",
      "poi_short_description": "Vibrant eatery with handmade tamales also serving large portions of Tex-Mex faves & margaritas.",
      "poi_long_description": "Vibrant eatery with handmade tamales also serving large portions of Tex-Mex faves & margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ec-fa3b-732c-b2ca-c005854d27cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-fa3b-732c-b2ca-c005854d27cf",
        "storage_key": "property/5647035332034560/019f14ec-fa3b-732c-b2ca-c005854d27cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.gopalenque.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4798537632858391026&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-palenque",
      "poi_latitude": "30.0741317",
      "poi_longitude": "-95.4350753",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-353-4055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fabb4dbf5b98",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWc9DPR41R4YR8kHep43Ul0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_582fa261cae9e2dd9478f2ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "The Republic Grille",
      "poi_type": "Restaurants",
      "poi_address": "3486 Discovery Creek Blvd, Spring, TX 77386, USA",
      "poi_short_description": "Casual fixture with an eclectic Texas Hill Country vibe serving standards such as chicken-fried steak and burgers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ec-f611-71cd-9038-df8881828517.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-f611-71cd-9038-df8881828517",
        "storage_key": "property/5647035332034560/019f14ec-f611-71cd-9038-df8881828517.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.therepublicgrille.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7081267063557386254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-republic-grille",
      "poi_latitude": "30.106203",
      "poi_longitude": "-95.3889617",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-719-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fabb4dbf5b98",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFzaC9eBLR4YRDvACS-C2RWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_ded1db2626e29ff42b2d191e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "The Olive Oil Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "373 Sawdust Rd, Spring, TX 77380, USA",
      "poi_short_description": "Greek eatery with murals on the walls offering standard fare along with live belly dancers.",
      "poi_long_description": "Greek eatery with murals on the walls offering standard fare along with live belly dancers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ec-fa37-7308-98b3-f7c8d9666c92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-fa37-7308-98b3-f7c8d9666c92",
        "storage_key": "property/5647035332034560/019f14ec-fa37-7308-98b3-f7c8d9666c92.webp",
        "width": 1280,
        "height": 975
      },
      "poi_business_url": "https://theoliveoilrestaurant.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=5401703646784907247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-olive-oil-restaurant",
      "poi_latitude": "30.1243728",
      "poi_longitude": "-95.4461684",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-367-0114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fabb4dbf5b98",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzXf40zo0R4YR7-eL6Ni09ko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "ec_704389a7be94e841e54e63bb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "The Omega Grill",
      "poi_type": "Restaurants",
      "poi_address": "399 Sawdust Rd, Spring, TX 77380, USA",
      "poi_short_description": "Brick-lined dining room offering American comfort foods with full bar & weekday happy hour.",
      "poi_long_description": "Brick-lined dining room offering American comfort foods with full bar & weekday happy hour.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-0570-753b-a8e7-def87015a6fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-0570-753b-a8e7-def87015a6fc",
        "storage_key": "property/5647035332034560/019f14ed-0570-753b-a8e7-def87015a6fc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://theomegagrill.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=4857147125067479565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-omega-grill",
      "poi_latitude": "30.1243917",
      "poi_longitude": "-95.4470167",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 832-299-6665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fabb4dbf5b98",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlcozhzo0R4YRDfp0c5MNaEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_59e6ef483385e1c748b39eda",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Rudy's \"Country Store\" and Bar-B-Q",
      "poi_type": "Restaurants",
      "poi_address": "20806 Interstate 45 N, Spring, TX 77373, USA",
      "poi_short_description": "Brisket, ribs & sides served up cafeteria-style in a no-frills setting with indoor picnic tables.",
      "poi_long_description": "Brisket, ribs & sides served up cafeteria-style in a no-frills setting with indoor picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-056f-77bf-a83b-ec104afec49e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-056f-77bf-a83b-ec104afec49e",
        "storage_key": "property/5647035332034560/019f14ed-056f-77bf-a83b-ec104afec49e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://rudysbbq.com/location/detail/houston-i45n-spring-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3909932744436653281&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rudys-country-store-and-bar-b-q",
      "poi_latitude": "30.0681956",
      "poi_longitude": "-95.4335707",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-288-0916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fabb4dbf5b98",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE9YITCA1R4YR4ZzQhx3fQjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_1fc9a1a2b0744808ffbcf343",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "3B's Burgers & Beer",
      "poi_type": "Restaurants",
      "poi_address": "466 Rayford Rd #107, Spring, TX 77386, USA",
      "poi_short_description": "Low-key, family-friendly pub offering beef & chicken burgers, beer, TVs & pool tables.",
      "poi_long_description": "Low-key, family-friendly pub offering beef & chicken burgers, beer, TVs & pool tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-065f-73ed-85b7-d2b15ca2fcf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-065f-73ed-85b7-d2b15ca2fcf9",
        "storage_key": "property/5647035332034560/019f14ed-065f-73ed-85b7-d2b15ca2fcf9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.3bs-burgers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2131857294008295422&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "3bs-burgers--beer",
      "poi_latitude": "30.126846",
      "poi_longitude": "-95.435284",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-419-3553",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fabb4dbf5b98",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7MFT801R4YR_p8w8englR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_37628fed6cbefdf11b758eaa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Island Grill",
      "poi_type": "Restaurants",
      "poi_address": "1701 City Plaza Dr Ste 120, Spring, TX 77389, USA",
      "poi_short_description": "Casual juice bar offering smoothies & health-conscious food with a Mediterranean accent.",
      "poi_long_description": "Casual juice bar offering smoothies & health-conscious food with a Mediterranean accent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-0a16-72ac-9e94-fae801d4705a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-0a16-72ac-9e94-fae801d4705a",
        "storage_key": "property/5647035332034560/019f14ed-0a16-72ac-9e94-fae801d4705a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.islandgrillhouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12985763511692638443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "island-grill",
      "poi_latitude": "30.0980266",
      "poi_longitude": "-95.4416107",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-466-2559",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fabb4dbf5b98",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJxYFLU41R4YR6zirwxyzNrQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "ec_abd75d8a19327612ba6a109c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "24809 Aldine Westfield Rd, Spring, TX 77373, USA",
      "poi_short_description": "Neighborhood branch offering a wide selection of items, including groceries and gas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-08f8-71b1-a377-8b54d8e7f93c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-08f8-71b1-a377-8b54d8e7f93c",
        "storage_key": "property/5647035332034560/019f14ed-08f8-71b1-a377-8b54d8e7f93c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/5353-spring-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13916253705029025186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "30.0643945",
      "poi_longitude": "-95.4059813",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-203-3323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-487a-76b1-b489-63807cf5faa5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-487a-76b1-b489-63807cf5faa5",
        "storage_key": "property/5647035332034560/019f14ea-487a-76b1-b489-63807cf5faa5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyNycFo1R4YRov13ZAN3IME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_723ab12df1e6b3782159e4db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "24802 Aldine Westfield Rd, Spring, TX 77373, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-08ea-778b-8ef5-3157e06719b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-08ea-778b-8ef5-3157e06719b3",
        "storage_key": "property/5647035332034560/019f14ed-08ea-778b-8ef5-3157e06719b3.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/spring-tx-pharmacies/24802-aldine-westfield-spring-tx-77373/storeid=5977?WT.mc_id=LS_GOOGLE_RX_5977",
      "poi_directions_map_url": "https://maps.google.com/?cid=4727179092493778686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "30.0655065",
      "poi_longitude": "-95.4041483",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-288-1561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-4b52-75ff-8c80-0aefe249c63a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4b52-75ff-8c80-0aefe249c63a",
        "storage_key": "property/5647035332034560/019f14ed-4b52-75ff-8c80-0aefe249c63a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ628iqlw1R4YR_r6-xVZQmkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_1a9deb7deed6f08d4caf56e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "25500 Aldine Westfield Rd, Spring, TX 77373, USA",
      "poi_short_description": "Convenience-store chain with lots of food & drink options. Most sell fuel & some have car washes.",
      "poi_long_description": "Convenience-store chain with lots of food & drink options. Most sell fuel & some have car washes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-0a8a-72d8-a4ee-b9ae1cdb29a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-0a8a-72d8-a4ee-b9ae1cdb29a4",
        "storage_key": "property/5647035332034560/019f14ed-0a8a-72d8-a4ee-b9ae1cdb29a4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/spring/25500-aldine-westfield-rd/2741405?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=12675659680209872944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "30.0710322",
      "poi_longitude": "-95.408363",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-350-5547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-4b4e-742d-9336-b1071710aba2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4b4e-742d-9336-b1071710aba2",
        "storage_key": "property/5647035332034560/019f14ed-4b4e-742d-9336-b1071710aba2.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJN-hPdUI1R4YRMKimFFL96K8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_e50ea235647f710fb146fb8f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Cypresswood Pharmacy And Compounding",
      "poi_type": "Shopping & Retail",
      "poi_address": "26830 Cypresswood Dr Ste 101, Spring, TX 77373, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-0c24-7440-8f9b-0c0d5182e6bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-0c24-7440-8f9b-0c0d5182e6bf",
        "storage_key": "property/5647035332034560/019f14ed-0c24-7440-8f9b-0c0d5182e6bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cypresswoodpharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15629163976713783060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cypresswood-pharmacy-and-compounding",
      "poi_latitude": "30.0634907",
      "poi_longitude": "-95.393996",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-651-2374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-4b52-75ff-8c80-0aefe249c63a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4b52-75ff-8c80-0aefe249c63a",
        "storage_key": "property/5647035332034560/019f14ed-4b52-75ff-8c80-0aefe249c63a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR3u6Kss1R4YRFEdbeNTx5dg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_307e4b336027a2a55ea8708c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "155 Louetta Crossing, Spring, TX 77373, USA",
      "poi_short_description": "Department store offering a wide selection of items, including clothing, appliances, and furniture.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-0f2c-77c0-bee6-401f4bfdf04a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-0f2c-77c0-bee6-401f4bfdf04a",
        "storage_key": "property/5647035332034560/019f14ed-0f2c-77c0-bee6-401f4bfdf04a.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/849-spring-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11495825913360180022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "30.0647449",
      "poi_longitude": "-95.4302867",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-651-9963",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fd2b28b91d42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fd2b28b91d42",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fd2b28b91d42.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJRQYj-hI1R4YRNmOQvcJgiZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_da5ec0ce1045b73e63207c86",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "20131 I-45, Spring, TX 77373, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-0a32-767a-b631-ec7a5cf3fed0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-0a32-767a-b631-ec7a5cf3fed0",
        "storage_key": "property/5647035332034560/019f14ea-0a32-767a-b631-ec7a5cf3fed0.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Spring/TX/Spring/77373/568?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6541143526401260290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "30.0563707",
      "poi_longitude": "-95.434527",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-288-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fd2b28b91d42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fd2b28b91d42",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fd2b28b91d42.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJx2H1YNTKQIYRAjv-e2HPxlo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_d9ece79549b7239f65cbba2f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "20614 Interstate 45 N, Spring, TX 77373, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-10ee-772f-aa92-3a2bb47984f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-10ee-772f-aa92-3a2bb47984f6",
        "storage_key": "property/5647035332034560/019f14ed-10ee-772f-aa92-3a2bb47984f6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kohls.com/stores/tx/spring-549.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17339381590871645552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kohls",
      "poi_latitude": "30.0665109",
      "poi_longitude": "-95.4294358",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-528-6904",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fd2b28b91d42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fd2b28b91d42",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fd2b28b91d42.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyyQQ2iM1R4YRcB3aXLDbofA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_03ee1a0387e1c07f9e02eed9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "20618 Interstate 45 N, Spring, TX 77373, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-0e07-72e5-a780-c73da4c9eeaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-0e07-72e5-a780-c73da4c9eeaf",
        "storage_key": "property/5647035332034560/019f14ed-0e07-72e5-a780-c73da4c9eeaf.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9994925133549391273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "30.0672149",
      "poi_longitude": "-95.4296179",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-288-8581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fd2b28b91d42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fd2b28b91d42",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fd2b28b91d42.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJmdCDLCI1R4YRqc3VHXQbtYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "ec_73399e5ae51bf22e2e482417",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Michaels",
      "poi_type": "Shopping & Retail",
      "poi_address": "20626 I-45 N Louetta Central, Spring, TX 77373, USA",
      "poi_short_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_long_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-0ee7-7752-9c19-53e72fcf3938.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-0ee7-7752-9c19-53e72fcf3938",
        "storage_key": "property/5647035332034560/019f14ed-0ee7-7752-9c19-53e72fcf3938.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.michaels.com/TX/Spring/2760/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=17884548550155964591&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "michaels",
      "poi_latitude": "30.0675584",
      "poi_longitude": "-95.4297137",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-353-5031",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fd2b28b91d42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fd2b28b91d42",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fd2b28b91d42.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFaGwwSA1R4YRrxBGZCauMvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_bc50ddc14b7b9bbe6c7038c0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "20201 I-45, Spring, TX 77388, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-0eeb-72ec-8277-4f6a69ee64d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-0eeb-72ec-8277-4f6a69ee64d0",
        "storage_key": "property/5647035332034560/019f14ed-0eeb-72ec-8277-4f6a69ee64d0.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TX-Spring/0563?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-563-_-na-_-0-_-0&y_source=1_MTE4MzAwNy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13705856139270642621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "30.059924",
      "poi_longitude": "-95.434791",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-528-0909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fd2b28b91d42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fd2b28b91d42",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fd2b28b91d42.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa_i3lCc1R4YRvVvVu4r7NL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_49cb712db3122bf9c560dda5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Northgate Crossing Elementary",
      "poi_type": "Education",
      "poi_address": "23437 Northgate Crossing Blvd, Spring, TX 77373, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-10e1-72d6-af51-ce8ec620a8da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-10e1-72d6-af51-ce8ec620a8da",
        "storage_key": "property/5647035332034560/019f14ed-10e1-72d6-af51-ce8ec620a8da.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.springisd.org/northgate2",
      "poi_directions_map_url": "https://maps.google.com/?cid=5118635094390124254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northgate-crossing-elementary",
      "poi_latitude": "30.1025242",
      "poi_longitude": "-95.4311097",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 281-891-8780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48b2-74bb-9cb6-eae9c1263b4b",
        "storage_key": "property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6anZJK41R4YR3q74p38LCUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_d783fcf43f11486ef65efb1e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Hirsch Elementary School",
      "poi_type": "Education",
      "poi_address": "2633 Trailing Vine Rd, Spring, TX 77373, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://hirsch.springisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4199638180871100550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hirsch-elementary-school",
      "poi_latitude": "30.0501765",
      "poi_longitude": "-95.3933773",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-891-8330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48b2-74bb-9cb6-eae9c1263b4b",
        "storage_key": "property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCZ17sqpKR4YRhlj9w6wcSDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_878ca538827c2a76fa40b3ba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Springwoods Village Middle School",
      "poi_type": "Education",
      "poi_address": "1120 Crossgate Blvd, Spring, TX 77373, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.springisd.org/springwoods",
      "poi_directions_map_url": "https://maps.google.com/?cid=2181162663858775596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "springwoods-village-middle-school",
      "poi_latitude": "30.09983969999999",
      "poi_longitude": "-95.4318609",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-891-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48b2-74bb-9cb6-eae9c1263b4b",
        "storage_key": "property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuWOzrDw1R4YRLKal8OILRR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_1ddcde5382e6bfed09d269de",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Dueitt Middle School",
      "poi_type": "Education",
      "poi_address": "1 Eagle Crossing, Spring, TX 77373, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-1390-7481-b02e-2b885ba96df2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-1390-7481-b02e-2b885ba96df2",
        "storage_key": "property/5647035332034560/019f14ed-1390-7481-b02e-2b885ba96df2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.springisd.org/o/dms",
      "poi_directions_map_url": "https://maps.google.com/?cid=3343534337512739845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dueitt-middle-school",
      "poi_latitude": "30.0459961",
      "poi_longitude": "-95.3539677",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 281-891-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48b2-74bb-9cb6-eae9c1263b4b",
        "storage_key": "property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ28j4FSq1QIYRBZTE4cOeZi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_4527a8ae321215e42fe5df91",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Spring High School",
      "poi_type": "Education",
      "poi_address": "19428 I-45, Spring, TX 77373, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-11be-71ce-9367-b2e4a3b13418.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-11be-71ce-9367-b2e4a3b13418",
        "storage_key": "property/5647035332034560/019f14ed-11be-71ce-9367-b2e4a3b13418.webp",
        "width": 1080,
        "height": 722
      },
      "poi_business_url": "https://shs.springisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11252289792991556920&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-high-school",
      "poi_latitude": "30.0540885",
      "poi_longitude": "-95.4289735",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-891-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48b2-74bb-9cb6-eae9c1263b4b",
        "storage_key": "property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2y8_rS41R4YROPUDFfMpKJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_a58e6219ff128b94e991c1b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Carl Wunsche Sr. High School",
      "poi_type": "Education",
      "poi_address": "900 Wunsche Loop, Spring, TX 77373, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-1663-72c9-8bd0-bbc82beeb831.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-1663-72c9-8bd0-bbc82beeb831",
        "storage_key": "property/5647035332034560/019f14ed-1663-72c9-8bd0-bbc82beeb831.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.springisd.org/wunsche2",
      "poi_directions_map_url": "https://maps.google.com/?cid=10749498856943237617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carl-wunsche-sr-high-school",
      "poi_latitude": "30.0799395",
      "poi_longitude": "-95.4266343",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-891-7650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48b2-74bb-9cb6-eae9c1263b4b",
        "storage_key": "property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfaMeTho1R4YR8bmR0UHkLZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_22b015516e7e6809bc8a19d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Westfield High School",
      "poi_type": "Education",
      "poi_address": "16713 Ella Blvd, Houston, TX 77090, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-16c2-72d9-8f79-07e374315037.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-16c2-72d9-8f79-07e374315037",
        "storage_key": "property/5647035332034560/019f14ed-16c2-72d9-8f79-07e374315037.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.springisd.org/westfield2",
      "poi_directions_map_url": "https://maps.google.com/?cid=13948870692140090160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westfield-high-school",
      "poi_latitude": "30.0071245",
      "poi_longitude": "-95.4468572",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-891-7130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48b2-74bb-9cb6-eae9c1263b4b",
        "storage_key": "property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgz_JjgXLQIYRMAPefv1XlME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_e7f78299bc34217ebeb40589",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Founders Christian School",
      "poi_type": "Education",
      "poi_address": "24724 Aldine Westfield Rd Basecamp 1, Spring, TX 77373, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-13a5-7230-8cd2-0f7cf49bbe42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-13a5-7230-8cd2-0f7cf49bbe42",
        "storage_key": "property/5647035332034560/019f14ed-13a5-7230-8cd2-0f7cf49bbe42.webp",
        "width": 1024,
        "height": 327
      },
      "poi_business_url": "http://www.founderschristian.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6633250446045507368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "founders-christian-school",
      "poi_latitude": "30.0646687",
      "poi_longitude": "-95.4029623",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-602-8006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48b2-74bb-9cb6-eae9c1263b4b",
        "storage_key": "property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJneZcels1R4YRKG--3iIKDlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_58ac5b3e1dcbb433e956bc2a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Frassati Catholic High School",
      "poi_type": "Education",
      "poi_address": "22151 Frassati Way, Spring, TX 77389, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-18f8-70e4-a873-6aa5808ef192.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-18f8-70e4-a873-6aa5808ef192",
        "storage_key": "property/5647035332034560/019f14ed-18f8-70e4-a873-6aa5808ef192.webp",
        "width": 1280,
        "height": 739
      },
      "poi_business_url": "http://www.frassaticatholic.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16686743324239437157&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frassati-catholic-high-school",
      "poi_latitude": "30.0858877",
      "poi_longitude": "-95.4898693",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 832-616-3217",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48b2-74bb-9cb6-eae9c1263b4b",
        "storage_key": "property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_RGyQXczR4YRZZ1pq6Q4k-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_5aab0ed609fbe9dbf5ef032e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Lone Star College Montgomery",
      "poi_type": "Education",
      "poi_address": "3200 College Park Dr, Conroe, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-1640-772e-b84f-f1dc86c3e3d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-1640-772e-b84f-f1dc86c3e3d4",
        "storage_key": "property/5647035332034560/019f14ed-1640-772e-b84f-f1dc86c3e3d4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.lonestar.edu/montgomery",
      "poi_directions_map_url": "https://maps.google.com/?cid=14910642082803884477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lone-star-college-montgomery",
      "poi_latitude": "30.2103106",
      "poi_longitude": "-95.4682838",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 936-273-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48b2-74bb-9cb6-eae9c1263b4b",
        "storage_key": "property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7ZMdJEY3R4YRvSGEbvk97c4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_a5200e0354e4528d31c400dc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Topgolf Spring",
      "poi_type": "Entertainment",
      "poi_address": "560 Spring Park Center Blvd, Spring, TX 77373, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-0a32-767a-b631-ea46e20c238a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-0a32-767a-b631-ea46e20c238a",
        "storage_key": "property/5647035332034560/019f14ea-0a32-767a-b631-ea46e20c238a.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://topgolf.com/us/houston-north/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8552608197193025455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-spring",
      "poi_latitude": "30.0481616",
      "poi_longitude": "-95.4264931",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 832-200-0106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fabb4dbf5b98",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fabb4dbf5b98.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX8HkMC01R4YRr8fIeNf3sHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_c3f956fabb47503b9faa5c24",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Hurricane Harbor Splashtown",
      "poi_type": "Entertainment",
      "poi_address": "21300 Interstate 45 N, Spring, TX 77373, USA",
      "poi_short_description": "Popular water amusement park with slides, lazy river & varied attractions for multiple age groups.",
      "poi_long_description": "Popular water amusement park with slides, lazy river & varied attractions for multiple age groups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-127e-75ba-a395-59244f3aba30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-127e-75ba-a395-59244f3aba30",
        "storage_key": "property/5647035332034560/019f14ea-127e-75ba-a395-59244f3aba30.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sixflags.com/splashtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=4235833718712195775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hurricane-harbor-splashtown",
      "poi_latitude": "30.0710065",
      "poi_longitude": "-95.4328982",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-355-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzQcpfR81R4YRv1p2I1O0yDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "ec_d0719892d96bb7d0c27fd310",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Big Rivers Waterpark & Adventures",
      "poi_type": "Entertainment",
      "poi_address": "23101 TX-242, New Caney, TX 77357, USA",
      "poi_short_description": "Aquatic center with colorful water slides, zip lines & splash pads, plus turtles & baby alligators.",
      "poi_long_description": "Aquatic center with colorful water slides, zip lines & splash pads, plus turtles & baby alligators.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-1b5b-73dc-a39b-2c624d18d693.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-1b5b-73dc-a39b-2c624d18d693",
        "storage_key": "property/5647035332034560/019f14ed-1b5b-73dc-a39b-2c624d18d693.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bigriverswaterpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14179803201278957095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-rivers-waterpark--adventures",
      "poi_latitude": "30.1960545",
      "poi_longitude": "-95.1995318",
      "poi_miles_from_property": "31.3 mi",
      "poi_walking_minutes": "11 hours 23 mins",
      "poi_biking_minutes": "2 hours 29 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 832-509-1556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO3QgrLVRR4YRJ9YtPeLHyMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "ec_674197a4067ca950e604e40a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "The Cynthia Woods Mitchell Pavilion",
      "poi_type": "Entertainment",
      "poi_address": "2005 Lake Robbins Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Unique outdoor performance space surrounded by trees features live music, theater & dance shows.",
      "poi_long_description": "Unique outdoor performance space surrounded by trees features live music, theater & dance shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-1c31-74f8-8917-f3870fbdb070.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-1c31-74f8-8917-f3870fbdb070",
        "storage_key": "property/5647035332034560/019f14ed-1c31-74f8-8917-f3870fbdb070.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.woodlandscenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9903810310770188732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-cynthia-woods-mitchell-pavilion",
      "poi_latitude": "30.1614265",
      "poi_longitude": "-95.4640655",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-364-3010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWcAcMc2R4YRvOFOSAFncYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "ec_feebf7e5462a53a5a15fec36",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Town Green Park",
      "poi_type": "Entertainment",
      "poi_address": "2099 Lake Robbins Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Immense open lawns highlight this public green space which features an amphitheater & a labyrinth.",
      "poi_long_description": "Immense open lawns highlight this public green space which features an amphitheater & a labyrinth.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-2785-777d-a06c-a55c4369052e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-2785-777d-a06c-a55c4369052e",
        "storage_key": "property/5647035332034560/019f14ea-2785-777d-a06c-a55c4369052e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://woodlandsevents.com/parks/town-center/town-green-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8406987068125119440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-green-park",
      "poi_latitude": "30.1617206",
      "poi_longitude": "-95.466142",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-210-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48af-705f-8866-b5b3a9192b90",
        "storage_key": "property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdTr47Mc2R4YR0IPmQjKeq3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ac3ce9709271e44e121af1f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Market Street",
      "poi_type": "Entertainment",
      "poi_address": "9595 Six Pines Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "Trendy, mixed-use town center housing luxury retailers, upscale restaurants, bars & a movie theater.",
      "poi_long_description": "Trendy, mixed-use town center housing luxury retailers, upscale restaurants, bars & a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-1a23-718e-b748-c26a25307570.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-1a23-718e-b748-c26a25307570",
        "storage_key": "property/5647035332034560/019f14ed-1a23-718e-b748-c26a25307570.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://shopatmarketstreet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10104591045945142808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "market-street",
      "poi_latitude": "30.1638371",
      "poi_longitude": "-95.4635036",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-419-4774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-fd2b28b91d42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-fd2b28b91d42",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-fd2b28b91d42.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKVeL_8Y2R4YRGC4nFgW4Oow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_f85c7910f32067f6137bc661",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Old Town Spring",
      "poi_type": "Entertainment",
      "poi_address": "403 Main St, Spring, TX 77373, USA",
      "poi_short_description": "Historic turn-of-the-century settlement features a variety of Victorian-style restaurants & shops.",
      "poi_long_description": "Historic turn-of-the-century settlement features a variety of Victorian-style restaurants & shops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-1a3e-749d-aad3-48ea671813c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-1a3e-749d-aad3-48ea671813c0",
        "storage_key": "property/5647035332034560/019f14ed-1a3e-749d-aad3-48ea671813c0.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://oldtownspringshopping.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=690816813901608507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-town-spring",
      "poi_latitude": "30.0789163",
      "poi_longitude": "-95.4210584",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-353-9310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiR1GdhE1R4YRO_Z4bTtGlgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "ec_43ca42099559a4a39777c4ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "AMC Spring 10",
      "poi_type": "Entertainment",
      "poi_address": "20115 Holzwarth Rd, Spring, TX 77388, USA",
      "poi_short_description": "Comfortable movie theater featuring reclining seats with leather upholstery and snacks and drinks for sale.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-1ee8-703e-9614-c1639fb27727.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-1ee8-703e-9614-c1639fb27727",
        "storage_key": "property/5647035332034560/019f14ed-1ee8-703e-9614-c1639fb27727.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/houston/amc-spring-10?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=18408731182930154681&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-spring-10",
      "poi_latitude": "30.0572631",
      "poi_longitude": "-95.4384621",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-288-5061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-4b3b-719c-b4b5-7a29551062ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4b3b-719c-b4b5-7a29551062ab",
        "storage_key": "property/5647035332034560/019f14ed-4b3b-719c-b4b5-7a29551062ab.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJV53Gmtc0R4YRuVQ1LHrzeP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_e792438e44c1984aae5f978d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Cinemark Spring-Klein and XD",
      "poi_type": "Entertainment",
      "poi_address": "21440 Kuykendahl Rd, Spring, TX 77379, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-1ee1-7713-9048-5c18e7bc4d79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-1ee1-7713-9048-5c18e7bc4d79",
        "storage_key": "property/5647035332034560/019f14ed-1ee1-7713-9048-5c18e7bc4d79.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-spring/cinemark-spring-klein-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMwNjktNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=6079670243275711382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-spring-klein-and-xd",
      "poi_latitude": "30.0806783",
      "poi_longitude": "-95.5180568",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-288-2894",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-4b3b-719c-b4b5-7a29551062ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4b3b-719c-b4b5-7a29551062ab",
        "storage_key": "property/5647035332034560/019f14ed-4b3b-719c-b4b5-7a29551062ab.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wDp5wIzR4YRliP28d9TX1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_61fc46c419591815bf38ae44",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "The Woodlands Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "4775 W Panther Creek Dr #280, The Woodlands, TX 77381, USA",
      "poi_short_description": "Interactive exhibits & imaginative play are the focus of this museum designed for young children.",
      "poi_long_description": "Interactive exhibits & imaginative play are the focus of this museum designed for young children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-1130-753b-b87f-fa6dc1ab7902.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-1130-753b-b87f-fa6dc1ab7902",
        "storage_key": "property/5647035332034560/019f14ea-1130-753b-b87f-fa6dc1ab7902.webp",
        "width": 400,
        "height": 400
      },
      "poi_business_url": "http://woodlandschildrensmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1661874245600597207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-woodlands-childrens-museum",
      "poi_latitude": "30.167706",
      "poi_longitude": "-95.502756",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-465-0955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-486a-774b-b747-a5c8eed71de0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-486a-774b-b747-a5c8eed71de0",
        "storage_key": "property/5647035332034560/019f14ea-486a-774b-b747-a5c8eed71de0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJqcYNveo2R4YR19RkRtIpEBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_da59f1dde30fec54a2f29519",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "RapidCare Emergency Room and Urgent ER Care - Spring/Woodlands",
      "poi_type": "Health and Wellness",
      "poi_address": "26306 Kuykendahl Rd, Spring, TX 77389, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-1ff8-7299-9587-18ab2d76aa5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-1ff8-7299-9587-18ab2d76aa5c",
        "storage_key": "property/5647035332034560/019f14ed-1ff8-7299-9587-18ab2d76aa5c.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://rapidcareemergency.com/locations/24-hr-emergency-room-near-spring/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7413091712591023390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rapidcare-emergency-room-and-urgent-er-care---springwoodlands",
      "poi_latitude": "30.14236709999999",
      "poi_longitude": "-95.5485747",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 832-639-4008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO4OkooQxR4YRHk1h6KKX4GY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_ff79375f4c44492ab588eb0a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Memorial Hermann The Woodlands Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "9250 Pinecroft Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-220f-7574-9cdb-00da46b653f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-220f-7574-9cdb-00da46b653f8",
        "storage_key": "property/5647035332034560/019f14ea-220f-7574-9cdb-00da46b653f8.webp",
        "width": 1280,
        "height": 1080
      },
      "poi_business_url": "https://memorialhermann.org/locations/woodlands?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=4980774261720927425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-the-woodlands-medical-center",
      "poi_latitude": "30.1743163",
      "poi_longitude": "-95.4542271",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 713-897-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48a8-7687-a60b-ec7eba774482.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48a8-7687-a60b-ec7eba774482",
        "storage_key": "property/5647035332034560/019f14ea-48a8-7687-a60b-ec7eba774482.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJgefV08Q2R4YRwcxIQM1DH0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_47b8ffec83d8924cec4d6979",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Spring Emergency Room",
      "poi_type": "Health and Wellness",
      "poi_address": "3515 Rayford Rd Ste 150, Spring, TX 77386, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-2192-7199-a32f-98dbf60d4800.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-2192-7199-a32f-98dbf60d4800",
        "storage_key": "property/5647035332034560/019f14ed-2192-7199-a32f-98dbf60d4800.webp",
        "width": 680,
        "height": 510
      },
      "poi_business_url": "https://spring-er.com/?utm_source=GMB&utm_medium=Organic&utm_campaign=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=3748339992554068780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-emergency-room",
      "poi_latitude": "30.1096949",
      "poi_longitude": "-95.3863889",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 832-252-9860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp0Mrxv1LR4YRLFuTGV3HBDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_71bc6b19b6078688939f1b28",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "24802 Aldine Westfield Rd, Spring, TX 77373, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-08ea-778b-8ef5-3157e06719b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-08ea-778b-8ef5-3157e06719b3",
        "storage_key": "property/5647035332034560/019f14ed-08ea-778b-8ef5-3157e06719b3.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/spring-tx-pharmacies/24802-aldine-westfield-spring-tx-77373/storeid=5977?WT.mc_id=LS_GOOGLE_RX_5977",
      "poi_directions_map_url": "https://maps.google.com/?cid=4727179092493778686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "30.0655065",
      "poi_longitude": "-95.4041483",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-288-1561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-4b52-75ff-8c80-0aefe249c63a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4b52-75ff-8c80-0aefe249c63a",
        "storage_key": "property/5647035332034560/019f14ed-4b52-75ff-8c80-0aefe249c63a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ628iqlw1R4YR_r6-xVZQmkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_b3110cee28e96e2850d8fb6d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "24809 Aldine Westfield Rd, Spring, TX 77373, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-2382-7197-9db7-add015b3a2e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-2382-7197-9db7-add015b3a2e1",
        "storage_key": "property/5647035332034560/019f14ed-2382-7197-9db7-add015b3a2e1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/5353-spring-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=12069052450600886600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "30.0643945",
      "poi_longitude": "-95.4059813",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-203-3320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-4b52-75ff-8c80-0aefe249c63a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4b52-75ff-8c80-0aefe249c63a",
        "storage_key": "property/5647035332034560/019f14ed-4b52-75ff-8c80-0aefe249c63a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyNycFo1R4YRSKGfXULjfac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_326b22966426f7ee5bb5e09f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "23110 Aldine Westfield Rd, Spring, TX 77373, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-22c0-75b5-8db1-369d100859d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-22c0-75b5-8db1-369d100859d7",
        "storage_key": "property/5647035332034560/019f14ed-22c0-75b5-8db1-369d100859d7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-23110+aldine+westfield+rd-spring-tx-77373/id=3424",
      "poi_directions_map_url": "https://maps.google.com/?cid=5124336768787965880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "30.0480822",
      "poi_longitude": "-95.3860608",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-350-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVxyE2FK1QIYRuGcULSRNHUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_73420f5c7980603f3e0e127e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5645 Treaschwig Rd, Spring, TX 77373, USA",
      "poi_short_description": "Clean gym that features workout machines and yoga classes and offers personal training.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-244d-745c-beff-5889e341a87d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-244d-745c-beff-5889e341a87d",
        "storage_key": "property/5647035332034560/019f14ed-244d-745c-beff-5889e341a87d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/spring-texas-2257/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=2257",
      "poi_directions_map_url": "https://maps.google.com/?cid=6836012273001764314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "30.0452308",
      "poi_longitude": "-95.3484954",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 281-784-2440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8caeAtS0QIYR2hV7jPFk3l4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_71fe8098f95788daa0e2dcd8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4747 Research Forest Dr Ste 445, The Woodlands, TX 77381, USA",
      "poi_short_description": "Chain studio, also referred to as a gym, specializing in cardio-based classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-2a36-7379-84da-4fb8f116a487.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-2a36-7379-84da-4fb8f116a487",
        "storage_key": "property/5647035332034560/019f14ed-2a36-7379-84da-4fb8f116a487.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/woodlands-texas-0753?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=2302129300454326209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "30.1843918",
      "poi_longitude": "-95.4900463",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 832-916-2115",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK77CUNgwR4YRwT-ZzGbO8h8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_01155eae88000525235e7273",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "9000 Six Pines Dr, Shenandoah, TX 77380, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, pickleball courts, and a large gym, plus coworking spaces.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-12c3-724c-87d9-0e633bc6a4ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-12c3-724c-87d9-0e633bc6a4ec",
        "storage_key": "property/5647035332034560/019f14ea-12c3-724c-87d9-0e633bc6a4ec.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/tx/shenandoah.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=16582555533018722512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "30.173734",
      "poi_longitude": "-95.459782",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 346-786-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeSb8S8A3R4YR0PDELWYSIeY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_efe8f529487e67117fde51cf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "StretchLab",
      "poi_type": "Health and Wellness",
      "poi_address": "2000 Hughes Landing Blvd #300, The Woodlands, TX 77380, USA",
      "poi_short_description": "Customized stretches and group classes (drop-in or by membership) in a clean facility.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-290d-757f-b786-8d4100fe5839.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-290d-757f-b786-8d4100fe5839",
        "storage_key": "property/5647035332034560/019f14ed-290d-757f-b786-8d4100fe5839.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://local.stretchlab.com/location/hugheslanding",
      "poi_directions_map_url": "https://maps.google.com/?cid=14613343517272138208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stretchlab",
      "poi_latitude": "30.16957099999999",
      "poi_longitude": "-95.472854",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 346-220-4375",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvwU3UZM3R4YR4GHDD4EGzco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_84c459f8efa15016ce004021",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Northwood Pines Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "23838 Northgate Crossing Blvd, Spring, TX 77373, USA",
      "poi_short_description": "Community green space showcasing a playground, swings and a scenic duck pond.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-2a87-77bf-b737-199d2fce4e51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-2a87-77bf-b737-199d2fce4e51",
        "storage_key": "property/5647035332034560/019f14ed-2a87-77bf-b737-199d2fce4e51.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6893889346628199091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwood-pines-park",
      "poi_latitude": "30.1069741",
      "poi_longitude": "-95.4262845",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 281-463-1777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48af-705f-8866-b5b3a9192b90",
        "storage_key": "property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJY_PkZLA1R4YRs6Kf2tUDrF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_deb223b2af9f32c09b95bab2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Southwell Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "27419 Nelson St, Spring, TX 77373, USA",
      "poi_short_description": "Kid-friendly area with a playground plus a basketball court.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-2a3d-742c-ae05-d0aab0f8a34b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-2a3d-742c-ae05-d0aab0f8a34b",
        "storage_key": "property/5647035332034560/019f14ed-2a3d-742c-ae05-d0aab0f8a34b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hcp4.wordpress.com/parks/southwell/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13693370324471227958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southwell-park",
      "poi_latitude": "30.0892674",
      "poi_longitude": "-95.4235076",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48af-705f-8866-b5b3a9192b90",
        "storage_key": "property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJj0zN2Ag1R4YRNqb7b8KfCL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f7074af7b1f83a6c05acb38c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Timber Lane Park Disc Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2615 Ciderwood Dr, Spring, TX 77373, USA",
      "poi_short_description": "Park with picnic tables, playgrounds, a splash pad, and a public restroom, plus trails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-2db5-732f-917f-d7b282ce7554.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-2db5-732f-917f-d7b282ce7554",
        "storage_key": "property/5647035332034560/019f14ed-2db5-732f-917f-d7b282ce7554.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.timberlaneud.com/index.php?page=12",
      "poi_directions_map_url": "https://maps.google.com/?cid=489344104532893786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "timber-lane-park-disc-golf-course",
      "poi_latitude": "30.0440452",
      "poi_longitude": "-95.3885942",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 832-265-0226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48af-705f-8866-b5b3a9192b90",
        "storage_key": "property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJa_XvC1S1QIYRWmCd095_ygY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d737496408fdb991f1a425d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Dennis Johnston Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "709 Riley Fuzzel Rd, Spring, TX 77373, USA",
      "poi_short_description": "This 45-acre park features a pavilion, a fishing pond, a butterfly & hummingbird garden & more.",
      "poi_long_description": "This 45-acre park features a pavilion, a fishing pond, a butterfly & hummingbird garden & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-2db8-731d-acbf-67598c492aff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-2db8-731d-acbf-67598c492aff",
        "storage_key": "property/5647035332034560/019f14ed-2db8-731d-acbf-67598c492aff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pct3.com/Explore/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=10515605264913375845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dennis-johnston-park",
      "poi_latitude": "30.0911933",
      "poi_longitude": "-95.411156",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-274-0930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48af-705f-8866-b5b3a9192b90",
        "storage_key": "property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ9KpU3Q1R4YRZaJjPUbv7pE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1917e3bad52dab7e3afdccc4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Pundt Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4129 Spring Creek Dr, Spring, TX 77373, USA",
      "poi_short_description": "Large recreation area offering multiple fishing lakes, unpaved trails, picnic areas & a dog park.",
      "poi_long_description": "Large recreation area offering multiple fishing lakes, unpaved trails, picnic areas & a dog park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-3137-7077-b788-776d7da754cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-3137-7077-b788-776d7da754cf",
        "storage_key": "property/5647035332034560/019f14ed-3137-7077-b788-776d7da754cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pct3.com/Explore/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=4049805824425800360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pundt-park",
      "poi_latitude": "30.0820654",
      "poi_longitude": "-95.3784021",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 713-274-0930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48af-705f-8866-b5b3a9192b90",
        "storage_key": "property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXfL_z5NKR4YRqDI1xvDMMzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e2a6a9ae7672bc2e6c9ef83c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Spring Creek Greenway Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1300 Riley Fuzzel Rd, Spring, TX 77386, USA",
      "poi_short_description": "Facility for natural history programs & wildlife exhibits, with trails, a fishing pond & playground.",
      "poi_long_description": "Facility for natural history programs & wildlife exhibits, with trails, a fishing pond & playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-357a-701d-9fad-1a4597177190.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-357a-701d-9fad-1a4597177190",
        "storage_key": "property/5647035332034560/019f14ed-357a-701d-9fad-1a4597177190.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://scgnaturecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5641412788558996010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-creek-greenway-nature-center",
      "poi_latitude": "30.095915",
      "poi_longitude": "-95.400957",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-364-4225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48af-705f-8866-b5b3a9192b90",
        "storage_key": "property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJm38dXoI1R4YRKqJnrQpTSk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_586e865e4afbfd1add4d5c14",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Mercer Botanic Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "22306 Aldine Westfield Rd, Humble, TX 77338, USA",
      "poi_short_description": "300 acres of native & cultivated plants along with butterflies, birds & special seasonal events.",
      "poi_long_description": "300 acres of native & cultivated plants along with butterflies, birds & special seasonal events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-25e4-74ad-b788-d44a8d3f7ee7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-25e4-74ad-b788-d44a8d3f7ee7",
        "storage_key": "property/5647035332034560/019f14ea-25e4-74ad-b788-d44a8d3f7ee7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.pct3.com/MBG",
      "poi_directions_map_url": "https://maps.google.com/?cid=2942094030102634232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercer-botanic-gardens",
      "poi_latitude": "30.03799549999999",
      "poi_longitude": "-95.381209",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 713-274-4160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbdxOdU-1QIYR-J4QuO5q1Cg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_e7e30ffe7edfac79af038dd8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Preservation Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "130 Spring School Rd, Spring, TX 77373, USA",
      "poi_short_description": "Outdoor space used for events such as festivals, BBQ cook-offs, and crawfish boils.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-31aa-710d-8d1e-a66c909c1611.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-31aa-710d-8d1e-a66c909c1611",
        "storage_key": "property/5647035332034560/019f14ed-31aa-710d-8d1e-a66c909c1611.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10267335341137613756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "preservation-park",
      "poi_latitude": "30.0772827",
      "poi_longitude": "-95.4193529",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48af-705f-8866-b5b3a9192b90",
        "storage_key": "property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEYN27hM1R4YRvFNSFhjnfI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_92afc3c5868b26a477d06111",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Fox Run Toddler Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "28708 Atherstone St, Spring, TX 77386, USA",
      "poi_short_description": "Shady space for toddlers featuring swings and slides, plus clean equipment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-37d1-7448-b038-96527082ba12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-37d1-7448-b038-96527082ba12",
        "storage_key": "property/5647035332034560/019f14ed-37d1-7448-b038-96527082ba12.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.foxrunhoa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9866216483549012700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fox-run-toddler-park",
      "poi_latitude": "30.1093147",
      "poi_longitude": "-95.3916022",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48af-705f-8866-b5b3a9192b90",
        "storage_key": "property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMSmMVHZKR4YR3OIKS57X64g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ddf8c01bc8bbeea567b087d1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Bayer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "24811 W Hardy Rd, Spring, TX 77373, USA",
      "poi_short_description": "This 36-acre park offers lighted softball & baseball fields, plus concession stands.",
      "poi_long_description": "This 36-acre park offers lighted softball & baseball fields, plus concession stands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-3707-77cc-b465-9bad5b40558f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-3707-77cc-b465-9bad5b40558f",
        "storage_key": "property/5647035332034560/019f14ed-3707-77cc-b465-9bad5b40558f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pct3.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14262423777283150095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bayer-park",
      "poi_latitude": "30.0598233",
      "poi_longitude": "-95.4160881",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48af-705f-8866-b5b3a9192b90",
        "storage_key": "property/5647035332034560/019f14ea-48af-705f-8866-b5b3a9192b90.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnWYtPTg1R4YRDxEMIdxO7sU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2e56bd3cd91ab1c73362f699",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Sawdust Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "701 Westridge Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-35e8-7416-99ec-b3d23d2a38e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-35e8-7416-99ec-b3d23d2a38e4",
        "storage_key": "property/5647035332034560/019f14ed-35e8-7416-99ec-b3d23d2a38e4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thewoodlandstownship-tx.gov/Departments/Transportation",
      "poi_directions_map_url": "https://maps.google.com/?cid=18193597785316610762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sawdust-park--ride",
      "poi_latitude": "30.1203476",
      "poi_longitude": "-95.4537629",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-363-0882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpx6oJzw0R4YRylIhvMqkfPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_db3dbf2e04965613e44171dc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Research Forest Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "3900 Marsico Pl, The Woodlands, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-3ce0-70b9-82fa-463f01268cfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-3ce0-70b9-82fa-463f01268cfd",
        "storage_key": "property/5647035332034560/019f14ed-3ce0-70b9-82fa-463f01268cfd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://woodlandstransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15778184797064041952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "research-forest-park--ride",
      "poi_latitude": "30.1927936",
      "poi_longitude": "-95.4748177",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 936-273-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKSOpKuM3R4YR4JV4_Xlf99o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_621392c99dfee47413ebe26f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Sterling Ridge Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "8001 McBeth Way, The Woodlands, TX 77382, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-38aa-7031-8d21-b5dd39d8a20c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-38aa-7031-8d21-b5dd39d8a20c",
        "storage_key": "property/5647035332034560/019f14ed-38aa-7031-8d21-b5dd39d8a20c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thewoodlandstownship-tx.gov/Departments/Transportation",
      "poi_directions_map_url": "https://maps.google.com/?cid=2548114769123178756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sterling-ridge-park--ride",
      "poi_latitude": "30.1812573",
      "poi_longitude": "-95.5592182",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 281-363-1325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqj4wR4YRBHmDzOG4XCM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_2443b05062021d0ec5510707",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "The Woodlands Township Trolley Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 Westridge Dr, Spring, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.thewoodlandstownship-tx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6273890671774275294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-woodlands-township-trolley-center",
      "poi_latitude": "30.1210626",
      "poi_longitude": "-95.4534343",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8RuuN-E1R4YR3ha-UlNWEVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_3856734b377a046b8f272aa6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "The Woodlands Township",
      "poi_type": "Transportation & Transit",
      "poi_address": "2801 Technology Forest Blvd, The Woodlands, TX 77381, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-3980-75e9-9426-32f8ea5bf3f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-3980-75e9-9426-32f8ea5bf3f4",
        "storage_key": "property/5647035332034560/019f14ed-3980-75e9-9426-32f8ea5bf3f4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.thewoodlandstownship-tx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15961375474051580714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-woodlands-township",
      "poi_latitude": "30.1769164",
      "poi_longitude": "-95.4796936",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-210-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-4b63-72fc-829f-729a4b751aaf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4b63-72fc-829f-729a4b751aaf",
        "storage_key": "property/5647035332034560/019f14ed-4b63-72fc-829f-729a4b751aaf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrZp9fJU2R4YRKgN6OW0ygt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_b5829d003b3bc25b2169f1f4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "George Bush Intercontinental Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2800 N Terminal Rd, Houston, TX 77032, USA",
      "poi_short_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_long_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-3d58-7727-8831-38f32d765987.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-3d58-7727-8831-38f32d765987",
        "storage_key": "property/5647035332034560/019f14ed-3d58-7727-8831-38f32d765987.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fly2houston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11296915713098302001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-bush-intercontinental-airport",
      "poi_latitude": "29.9931058",
      "poi_longitude": "-95.3416255",
      "poi_miles_from_property": "18.6 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 281-230-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-4b66-7421-8615-e9f821a4f544.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4b66-7421-8615-e9f821a4f544",
        "storage_key": "property/5647035332034560/019f14ed-4b66-7421-8615-e9f821a4f544.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1VD2SO0QIYRMcLAyPy0xpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_e25208c6e29b46c31640e488",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Conroe Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "131 1/2 Interstate 45 N, Conroe, TX 77304, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-3bd6-732b-89c1-27e515db81c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-3bd6-732b-89c1-27e515db81c3",
        "storage_key": "property/5647035332034560/019f14ed-3bd6-732b-89c1-27e515db81c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15554165986346127753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conroe-park--ride",
      "poi_latitude": "30.3093947",
      "poi_longitude": "-95.4696752",
      "poi_miles_from_property": "15.5 mi",
      "poi_walking_minutes": "5 hours 42 mins",
      "poi_biking_minutes": "2 hours 27 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 844-299-6242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-4b67-7740-a559-6a201b562368.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4b67-7740-a559-6a201b562368",
        "storage_key": "property/5647035332034560/019f14ed-4b67-7740-a559-6a201b562368.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJT80s6vg5R4YRidGfGY5_29c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_50c1352134b52e137223b7ca",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "ExxonMobil Houston Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "22777 Springwoods Village Pkwy, Spring, TX 77389, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-2b06-776d-a17f-658daa67619b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-2b06-776d-a17f-658daa67619b",
        "storage_key": "property/5647035332034560/019f14ea-2b06-776d-a17f-658daa67619b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://corporate.exxonmobil.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4652161626967610876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "exxonmobil-houston-campus",
      "poi_latitude": "30.1032818",
      "poi_longitude": "-95.4463252",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-582-3645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwbXzI1A0R4YR_JUb_VnMj0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_da3fe506ca8b66b91ccda878",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Chevron Phillips Chemical Company LP",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9500 Lakeside Blvd, The Woodlands, TX 77381, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-3c39-7393-860a-f2462a923903.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-3c39-7393-860a-f2462a923903",
        "storage_key": "property/5647035332034560/019f14ed-3c39-7393-860a-f2462a923903.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cpchem.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8985774748554964679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chevron-phillips-chemical-company-lp",
      "poi_latitude": "30.1721239",
      "poi_longitude": "-95.4746216",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 832-813-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi2HINLk2R4YRxy5Lb4bis3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_a18080f2853c02fecceb0a7e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Memorial Hermann The Woodlands Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9250 Pinecroft Dr, The Woodlands, TX 77380, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-220f-7574-9cdb-00da46b653f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ea-220f-7574-9cdb-00da46b653f8",
        "storage_key": "property/5647035332034560/019f14ea-220f-7574-9cdb-00da46b653f8.webp",
        "width": 1280,
        "height": 1080
      },
      "poi_business_url": "https://memorialhermann.org/locations/woodlands?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=4980774261720927425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-the-woodlands-medical-center",
      "poi_latitude": "30.1743163",
      "poi_longitude": "-95.4542271",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 713-897-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48a8-7687-a60b-ec7eba774482.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48a8-7687-a60b-ec7eba774482",
        "storage_key": "property/5647035332034560/019f14ea-48a8-7687-a60b-ec7eba774482.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJgefV08Q2R4YRwcxIQM1DH0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_8cb500300ee5acac60c61ee8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Houston Methodist The Woodlands Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17201 I-45, Conroe, TX 77385, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-4008-714d-9d4d-b389101f1256.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-4008-714d-9d4d-b389101f1256",
        "storage_key": "property/5647035332034560/019f14ed-4008-714d-9d4d-b389101f1256.webp",
        "width": 1140,
        "height": 560
      },
      "poi_business_url": "https://www.houstonmethodist.org/locations/the-woodlands/?utm_source=gmb&utm_medium=organic&utm_campaign=all_location_gmb&utm_content=website-click",
      "poi_directions_map_url": "https://maps.google.com/?cid=12078372465785096765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-methodist-the-woodlands-hospital",
      "poi_latitude": "30.20581229999999",
      "poi_longitude": "-95.4535176",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 936-270-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48a8-7687-a60b-ec7eba774482.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48a8-7687-a60b-ec7eba774482",
        "storage_key": "property/5647035332034560/019f14ea-48a8-7687-a60b-ec7eba774482.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJHVog23DAQIYRPcr6f8P_nqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_2e20d66182793598d6268fe5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Texas Children's Hospital The Woodlands Inpatient and Emergency",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17600 I-45, The Woodlands, TX 77384, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-421a-708b-b30f-a57668c4cb99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-421a-708b-b30f-a57668c4cb99",
        "storage_key": "property/5647035332034560/019f14ed-421a-708b-b30f-a57668c4cb99.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texaschildrens.org/locations/texas-childrens-hospital/the-woodlands",
      "poi_directions_map_url": "https://maps.google.com/?cid=9082928018215836934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-childrens-hospital-the-woodlands-inpatient-and-emergency",
      "poi_latitude": "30.20091439999999",
      "poi_longitude": "-95.4575802",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 936-267-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48a8-7687-a60b-ec7eba774482.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48a8-7687-a60b-ec7eba774482",
        "storage_key": "property/5647035332034560/019f14ea-48a8-7687-a60b-ec7eba774482.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsxSKWRU3R4YRBp0yvugKDX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_f164c05670e4641cc3091a7a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Lone Star College System Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5000 Research Forest Dr, The Woodlands, TX 77381, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-4664-7307-b1c2-0b957c43acf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-4664-7307-b1c2-0b957c43acf0",
        "storage_key": "property/5647035332034560/019f14ed-4664-7307-b1c2-0b957c43acf0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lonestar.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11872299323758135843&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lone-star-college-system-office",
      "poi_latitude": "30.187545",
      "poi_longitude": "-95.4885621",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 832-813-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48b2-74bb-9cb6-eae9c1263b4b",
        "storage_key": "property/5647035332034560/019f14ea-48b2-74bb-9cb6-eae9c1263b4b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz5LplNkwR4YRI8q2M1XhwqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_570143ec96f9627152d02d83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "The Woodlands Township",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2801 Technology Forest Blvd, The Woodlands, TX 77381, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-3980-75e9-9426-32f8ea5bf3f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-3980-75e9-9426-32f8ea5bf3f4",
        "storage_key": "property/5647035332034560/019f14ed-3980-75e9-9426-32f8ea5bf3f4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.thewoodlandstownship-tx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15961375474051580714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-woodlands-township",
      "poi_latitude": "30.1769164",
      "poi_longitude": "-95.4796936",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-210-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-4b63-72fc-829f-729a4b751aaf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4b63-72fc-829f-729a4b751aaf",
        "storage_key": "property/5647035332034560/019f14ed-4b63-72fc-829f-729a4b751aaf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrZp9fJU2R4YRKgN6OW0ygt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_37734566dc1566b34e7b686a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "HCA Houston Healthcare Conroe",
      "poi_type": "Major Employers & Offices",
      "poi_address": "504 Medical Center Blvd, Conroe, TX 77304, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-41c7-76a8-bc2f-624a49a30695.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-41c7-76a8-bc2f-624a49a30695",
        "storage_key": "property/5647035332034560/019f14ed-41c7-76a8-bc2f-624a49a30695.webp",
        "width": 864,
        "height": 486
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/conroe?utm__campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6581857409456557110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-conroe",
      "poi_latitude": "30.2845689",
      "poi_longitude": "-95.4677134",
      "poi_miles_from_property": "14.0 mi",
      "poi_walking_minutes": "5 hours 7 mins",
      "poi_biking_minutes": "2 hours 13 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 936-539-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-48a8-7687-a60b-ec7eba774482.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-48a8-7687-a60b-ec7eba774482",
        "storage_key": "property/5647035332034560/019f14ea-48a8-7687-a60b-ec7eba774482.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQe8nf3A5R4YRNkzuFHF0V1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_814be6f223f807f42a853655",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "Montgomery County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "301 N Main St, Conroe, TX 77301, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-421d-745e-be04-6761a4824b80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ed-421d-745e-be04-6761a4824b80",
        "storage_key": "property/5647035332034560/019f14ed-421d-745e-be04-6761a4824b80.webp",
        "width": 500,
        "height": 333
      },
      "poi_business_url": "http://www.mctx.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=650318029845271807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montgomery-county-courthouse",
      "poi_latitude": "30.3117346",
      "poi_longitude": "-95.4576066",
      "poi_miles_from_property": "15.5 mi",
      "poi_walking_minutes": "5 hours 42 mins",
      "poi_biking_minutes": "2 hours 24 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 936-756-0571",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ed-4b63-72fc-829f-729a4b751aaf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4b63-72fc-829f-729a4b751aaf",
        "storage_key": "property/5647035332034560/019f14ed-4b63-72fc-829f-729a4b751aaf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEUqKPEg5R4YR_5T1d81kBgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "ec_4d102a7979aec385a9217581",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "generator",
      "poi_name": "MP2 Energy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "909 Fannin St, Houston, TX 77010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.mp2energy.com/?utm_source=local&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2694348760262098261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mp2-energy",
      "poi_latitude": "29.7562695",
      "poi_longitude": "-95.3605767",
      "poi_miles_from_property": "26.0 mi",
      "poi_walking_minutes": "9 hours 32 mins",
      "poi_biking_minutes": "2 hours 24 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 832-510-1030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ea-4862-7061-8319-f79a5a9129c5",
        "storage_key": "property/5647035332034560/019f14ea-4862-7061-8319-f79a5a9129c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR8dZFUvTWBQRVb1vFOw_ZCU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    }
  ],
  "office_hours": [
    {
      "id": "custom_b8e7983e-4b6f-49d7-8eb9-d4a02f7c8e94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_eeb1f013-cb2a-48b5-add5-37c438f30a1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_71b40481-71c6-4f79-9821-1dfe4bd56ab4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a0f6da10-7f76-4a55-88ff-95f322de7beb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_78d56ca4-015a-4412-b6e7-35337d43b09e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_ca6e6b5c-7f02-444d-8421-88f138dc05ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_14d135a8-c1e4-40b6-9c04-849f2023ff4a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "19:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_3f3cdc2bb4f24cd32a4a0ffe",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "rating": "5",
      "name": "Linda Carolina Romero",
      "text": "I’ve been renting with American Landmark for almost two years—one year at Opal in Katy and nearly a year here. I’d like to share that the management team and staff have always been very kind and helpful. Ms. Catherine is truly a wonderful person, and since she arrived, you can feel a positive difference in the community. Everything appears more well-maintained, and the environment feels more organized overall.\n\nWhen we first moved in, the previous management handed over the apartment and it wasn’t quite ready yet. However, since the new management took over, everything has improved significantly. Any initial concerns were addressed, and our experience since then has been very positive. The community is peaceful, clean, and feels very safe. I enjoy going for walks with my son every day, and it genuinely feels like home to us.",
      "date": "2026-03-20",
      "title": "false"
    },
    {
      "id": "ec_3b7d24b27586212df18ecf38",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "rating": "5",
      "name": "Sanovia wilkins",
      "text": "I was looking for a good place for me and my kid a safe place and when I went in I was skeptical, but Kashanti made it easy ! I love the property and the people here are amazing the management are great! I moved in and it was a smooth transition.! Me and my child love it here .!!",
      "date": "2026-03-05",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_e4d60c6f-df27-4720-ac6d-3ccb49e593be",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019d02ef-a300-751a-9277-6ee16e6e2b2c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with a white couch, blue ottoman, and a TV mounted on the wall.",
        "public_id": "019d02ef-a300-751a-9277-6ee16e6e2b2c",
        "storage_key": "property/5647035332034560/019d02ef-a300-751a-9277-6ee16e6e2b2c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 974SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=QJMsgtVDTYr"
    },
    {
      "id": "custom_b379d9c6-f260-4ebc-b369-8369d4923a40",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019d02ef-a2a4-7158-9680-141ffa52f4c5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious apartment complex lobby with seating areas and modern decor.",
        "public_id": "019d02ef-a2a4-7158-9680-141ffa52f4c5",
        "storage_key": "property/5647035332034560/019d02ef-a2a4-7158-9680-141ffa52f4c5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hXS7WLw6GX6"
    },
    {
      "id": "custom_16dc8fe3-e8bd-42c6-aa1d-47a980c97f28",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019d02ee-f8b3-765a-a6bb-cd2e2f04c7d8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Empty bedroom with wood-look flooring and a ceiling fan.",
        "public_id": "019d02ee-f8b3-765a-a6bb-cd2e2f04c7d8",
        "storage_key": "property/5647035332034560/019d02ee-f8b3-765a-a6bb-cd2e2f04c7d8.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "1BR, 1BA - 701SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=NeGf7imeCRd"
    },
    {
      "id": "custom_11f09966-5888-41d5-a6b5-3ce0d0cc075d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f14c2-b637-768d-95ab-e0ae1bea0775.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-b637-768d-95ab-e0ae1bea0775",
        "storage_key": "property/5647035332034560/019f14c2-b637-768d-95ab-e0ae1bea0775.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "The Tribute | Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/8iPm9Do11JI"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-5dbd-7135-a5e1-2b1118aafe2f",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-tribute",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560"
    },
    {
      "lead_collector_id": "0198aa46-5e1e-71d1-a27b-eace19bd1a76",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-tribute",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560"
    },
    {
      "lead_collector_id": "0198aa46-5e81-71ba-9271-d648f9bf8dfc",
      "lead_source": "LANDING_PAGE",
      "name": "the-tribute",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "discover-studio-apartments-for-rent-in-spring-tx",
      "search_query": "Studio Apartments For Rent In Spring TX",
      "category": "Floorplan",
      "h1_title": "Discover Studio Apartments For Rent In Spring TX",
      "h2_subtitle": "The Tribute offers a unique living experience with elegant features and serene surroundings. Explore our studio apartments and find your perfect home today.",
      "page_copy": "Welcome to The Tribute, where studio apartments for rent in Spring TX offer a blend of comfort and style. Our community is designed with limitless possibilities, featuring elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views. Enjoy the tranquility of two ponds, a tropical-style swimming pool, and a 9-hole putting green, all tailored to enhance your living experience. \n\nInside your studio apartment, you'll find high-speed internet access, smoke-free living, and stainless steel appliances. The modern kitchen includes a pantry, microwave, and quartz countertops, perfect for culinary enthusiasts. With these features, The Tribute ensures a lifestyle of convenience and luxury. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Studio Apartments For Rent In Spring TX",
      "seo_description": "Explore The Tribute's studio apartments for rent in Spring TX. Enjoy elegant features and serene surroundings at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "explore-one-bedroom-apartments-for-rent-spring-tx",
      "search_query": "One Bedroom Apartments For Rent In Spring TX",
      "category": "Floorplan",
      "h1_title": "Explore One Bedroom Apartments For Rent In Spring TX",
      "h2_subtitle": "The Tribute offers beautifully designed one bedroom apartments with luxurious features. Discover your new home in a serene and vibrant community today.",
      "page_copy": "Welcome to The Tribute, where one bedroom apartments for rent in Spring TX provide a perfect blend of elegance and comfort. Our community is crafted with limitless possibilities, featuring elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views. Enjoy the serene environment with two ponds, a tropical-style swimming pool, and a 9-hole putting green, all designed to enhance your living experience. \n\nInside your one bedroom apartment, you'll find high-speed internet access, smoke-free living, and stainless steel appliances. The modern kitchen is equipped with a pantry, microwave, and quartz countertops, ideal for those who love to cook. With these features, The Tribute ensures a lifestyle of convenience and luxury. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | One Bedroom Apartments For Rent In Spring TX",
      "seo_description": "Discover The Tribute's one bedroom apartments for rent in Spring TX. Enjoy luxurious features and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "find-two-bedrooms-apartments-for-rent-in-spring-tx",
      "search_query": "Two Bedrooms Apartments For Rent In Spring TX",
      "category": "Floorplan",
      "h1_title": "Find Two Bedrooms Apartments For Rent In Spring TX",
      "h2_subtitle": "The Tribute offers spacious two bedroom apartments with luxurious features. Experience a vibrant community and make it your new home today.",
      "page_copy": "Welcome to The Tribute, where two bedrooms apartments for rent in Spring TX offer a spacious and elegant living experience. Our community is designed with limitless possibilities, featuring elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views. Enjoy the serene surroundings with two ponds, a tropical-style swimming pool, and a 9-hole putting green, all crafted to enhance your lifestyle. \n\nInside your two bedroom apartment, you'll find high-speed internet access, smoke-free living, and stainless steel appliances. The modern kitchen includes a pantry, microwave, and quartz countertops, perfect for those who enjoy cooking. With these features, The Tribute ensures a lifestyle of convenience and luxury. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Two Bedrooms Apartments For Rent In Spring TX",
      "seo_description": "Explore The Tribute's two bedrooms apartments for rent in Spring TX. Enjoy luxurious features and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Pool",
      "h2_subtitle": "The Tribute offers luxurious apartments with a stunning pool and vibrant community amenities. Find your perfect home in a serene and engaging environment today.",
      "page_copy": "Welcome to The Tribute, where apartments for rent near me with pool offer a perfect blend of luxury and leisure. Our community is designed with limitless possibilities, featuring elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views. Enjoy the tropical-style swimming pool, surrounded by two ponds and a 9-hole putting green, all crafted to enhance your lifestyle.\n\nIn addition to the pool, The Tribute features a fitness center, clubhouse, dog park, and controlled access for your convenience. The community also includes a courtyard, picnic area, volleyball court, and walk-up access, ensuring a vibrant and engaging living experience. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Apartments For Rent Near Me with Pool",
      "seo_description": "Explore The Tribute's apartments for rent near me with pool. Enjoy luxurious amenities and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Fitness Center",
      "h2_subtitle": "The Tribute offers modern apartments with a state-of-the-art fitness center and exceptional community amenities. Discover your ideal home in a vibrant setting today.",
      "page_copy": "Welcome to The Tribute, where apartments for rent near me with fitness center provide a perfect blend of comfort and convenience. Our community is designed with limitless possibilities, featuring elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views. Enjoy a state-of-the-art fitness center, surrounded by two ponds, a tropical-style swimming pool, and a 9-hole putting green, all crafted to enhance your lifestyle.\n\nBeyond the fitness center, The Tribute features a pool, clubhouse, dog park, and controlled access for your peace of mind. The community also includes a courtyard, picnic area, volleyball court, and walk-up access, ensuring a vibrant and engaging living experience. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Explore The Tribute's apartments for rent near me with fitness center. Enjoy modern amenities and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-dog-park",
      "search_query": "Apartments For Rent Near Me with Dog Park",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Dog Park",
      "h2_subtitle": "The Tribute offers pet-friendly apartments with a dedicated dog park and exceptional community amenities. Discover your ideal home in a vibrant setting today.",
      "page_copy": "Welcome to The Tribute, where apartments for rent near me with dog park provide a perfect blend of pet-friendly living and luxury. Our community is designed with limitless possibilities, featuring elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views. Enjoy a dedicated dog park, surrounded by two ponds, a tropical-style swimming pool, and a 9-hole putting green, all crafted to enhance your lifestyle.\n\nBeyond the dog park, The Tribute features a pool, fitness center, clubhouse, and controlled access for your peace of mind. The community also includes a courtyard, picnic area, volleyball court, and walk-up access, ensuring a vibrant and engaging living experience. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Apartments For Rent Near Me with Dog Park",
      "seo_description": "Explore The Tribute's apartments for rent near me with dog park. Enjoy pet-friendly amenities and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-spring-tx-near-unc-rex-hospital",
      "search_query": "Apartments For Rent In Spring TX Near UNC REX Hospital",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Spring TX Near UNC REX Hospital",
      "h2_subtitle": "The Tribute offers convenient apartments near UNC REX Hospital with luxurious features. Discover your ideal home in a vibrant and welcoming community today.",
      "page_copy": "Welcome to The Tribute, where apartments for rent in Spring TX near UNC REX Hospital offer a perfect blend of convenience and luxury. Our community is designed with limitless possibilities, featuring elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views. Enjoy proximity to UNC REX Hospital while living in a serene environment surrounded by two ponds, a tropical-style swimming pool, and a 9-hole putting green.\n\nThe Tribute features a range of amenities including controlled access, a clubhouse, fitness center, and dog park, ensuring a vibrant and engaging living experience. Inside your apartment, you'll find high-speed internet access, smoke-free living, and modern kitchens with stainless steel appliances, a pantry, microwave, and quartz countertops. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Apartments For Rent In Spring TX Near UNC REX Hospital",
      "seo_description": "Explore The Tribute's apartments for rent in Spring TX near UNC REX Hospital. Enjoy modern amenities and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-spring-tx-near-wakemed",
      "search_query": "Apartments For Rent In Spring TX Near WakeMed Heart & Vascular - Cardiovascular & Thoracic Surgery",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Spring TX Near WakeMed Heart & Vascular",
      "h2_subtitle": "The Tribute offers convenient apartments near WakeMed Heart & Vascular with luxurious features. Find your ideal home in a vibrant and welcoming community today.",
      "page_copy": "Welcome to The Tribute, where apartments for rent in Spring TX near WakeMed Heart & Vascular - Cardiovascular & Thoracic Surgery offer a perfect blend of convenience and luxury. Our community is designed with limitless possibilities, featuring elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views. Enjoy proximity to WakeMed Heart & Vascular while living in a serene environment surrounded by two ponds, a tropical-style swimming pool, and a 9-hole putting green.\n\nThe Tribute features a range of amenities including controlled access, a clubhouse, fitness center, and dog park, ensuring a vibrant and engaging living experience. Inside your apartment, you'll find high-speed internet access, smoke-free living, and modern kitchens with stainless steel appliances, a pantry, microwave, and quartz countertops. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Apartments For Rent In Spring TX Near WakeMed Heart & Vascular",
      "seo_description": "Explore The Tribute's apartments for rent in Spring TX near WakeMed Heart & Vascular. Enjoy modern amenities and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-spring-tx-near-center-wake-med",
      "search_query": "Apartments For Rent In Spring TX Near Center Wake Med Health Care",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Spring TX Near Center Wake Med Health Care",
      "h2_subtitle": "The Tribute offers convenient apartments near Center Wake Med Health Care with luxurious features. Discover your ideal home in a vibrant and welcoming community today.",
      "page_copy": "Welcome to The Tribute, where apartments for rent in Spring TX near Center Wake Med Health Care offer a perfect blend of convenience and luxury. Our community is designed with limitless possibilities, featuring elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views. Enjoy proximity to Center Wake Med Health Care while living in a serene environment surrounded by two ponds, a tropical-style swimming pool, and a 9-hole putting green.\n\nThe Tribute features a range of amenities including controlled access, a clubhouse, fitness center, and dog park, ensuring a vibrant and engaging living experience. Inside your apartment, you'll find high-speed internet access, smoke-free living, and modern kitchens with stainless steel appliances, a pantry, microwave, and quartz countertops. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Apartments For Rent In Spring TX Near Center Wake Med Health Care",
      "seo_description": "Explore The Tribute's apartments for rent in Spring TX near Center Wake Med Health Care. Enjoy modern amenities and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-spring-tx-near-mid-carolina",
      "search_query": "Apartments For Rent In Spring TX Near Mid-Carolina Obstetrics & Gynecology",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Spring TX Near Mid-Carolina Obstetrics & Gynecology",
      "h2_subtitle": "The Tribute offers convenient apartments near Mid-Carolina Obstetrics & Gynecology with luxurious features. Find your ideal home in a vibrant and welcoming community today.",
      "page_copy": "Welcome to The Tribute, where apartments for rent in Spring TX near Mid-Carolina Obstetrics & Gynecology offer a perfect blend of convenience and luxury. Our community is designed with limitless possibilities, featuring elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views. Enjoy proximity to Mid-Carolina Obstetrics & Gynecology while living in a serene environment surrounded by two ponds, a tropical-style swimming pool, and a 9-hole putting green.\n\nThe Tribute features a range of amenities including controlled access, a clubhouse, fitness center, and dog park, ensuring a vibrant and engaging living experience. Inside your apartment, you'll find high-speed internet access, smoke-free living, and modern kitchens with stainless steel appliances, a pantry, microwave, and quartz countertops. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Apartments For Rent In Spring TX Near Mid-Carolina Obstetrics & Gynecology",
      "seo_description": "Explore The Tribute's apartments for rent in Spring TX near Mid-Carolina Obstetrics & Gynecology. Enjoy modern amenities and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-spring-tx-near-duke-raleigh-hospital",
      "search_query": "Apartments For Rent In Spring TX Near Duke Raleigh Hospital, a Campus of Duke University Hospital",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Spring TX Near Duke Raleigh Hospital",
      "h2_subtitle": "The Tribute offers convenient apartments near Duke Raleigh Hospital with luxurious features. Discover your ideal home in a vibrant and welcoming community today.",
      "page_copy": "Welcome to The Tribute, where apartments for rent in Spring TX near Duke Raleigh Hospital, a Campus of Duke University Hospital, offer a perfect blend of convenience and luxury. Our community is designed with limitless possibilities, featuring elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views. Enjoy proximity to Duke Raleigh Hospital, known for exceptional medical care, while living in a serene environment surrounded by two ponds, a tropical-style swimming pool, and a 9-hole putting green.\n\nThe Tribute features a range of amenities including controlled access, a clubhouse, fitness center, and dog park, ensuring a vibrant and engaging living experience. Inside your apartment, you'll find high-speed internet access, smoke-free living, and modern kitchens with stainless steel appliances, a pantry, microwave, and quartz countertops. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Apartments For Rent In Spring TX Near Duke Raleigh Hospital",
      "seo_description": "Explore The Tribute's apartments for rent in Spring TX near Duke Raleigh Hospital. Enjoy modern amenities and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-spring-tx-near-ncsu",
      "search_query": "Apartments For Rent In Spring TX Near North Carolina State University",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Spring TX Near North Carolina State University",
      "h2_subtitle": "The Tribute offers convenient apartments near North Carolina State University with luxurious features. Find your ideal home in a vibrant and welcoming community today.",
      "page_copy": "Welcome to The Tribute, where apartments for rent in Spring TX near North Carolina State University offer a perfect blend of convenience and luxury. Our community is designed with limitless possibilities, featuring elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views. Enjoy proximity to North Carolina State University while living in a serene environment surrounded by two ponds, a tropical-style swimming pool, and a 9-hole putting green.\n\nThe Tribute features a range of amenities including controlled access, a clubhouse, fitness center, and dog park, ensuring a vibrant and engaging living experience. Inside your apartment, you'll find high-speed internet access, smoke-free living, and modern kitchens with stainless steel appliances, a pantry, microwave, and quartz countertops. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Apartments For Rent In Spring TX Near North Carolina State University",
      "seo_description": "Explore The Tribute's apartments for rent in Spring TX near North Carolina State University. Enjoy modern amenities and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-spring-tx-near-meredith-college",
      "search_query": "Apartments For Rent In Spring TX Near Meredith College",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Spring TX Near Meredith College",
      "h2_subtitle": "The Tribute offers convenient apartments near Meredith College with luxurious features. Discover your ideal home in a vibrant and welcoming community today.",
      "page_copy": "Welcome to The Tribute, where apartments for rent in Spring TX near Meredith College offer a perfect blend of convenience and luxury. Our community is designed with limitless possibilities, featuring elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views. Enjoy proximity to Meredith College while living in a serene environment surrounded by two ponds, a tropical-style swimming pool, and a 9-hole putting green.\n\nThe Tribute features a range of amenities including controlled access, a clubhouse, fitness center, and dog park, ensuring a vibrant and engaging living experience. Inside your apartment, you'll find high-speed internet access, smoke-free living, and modern kitchens with stainless steel appliances, a pantry, microwave, and quartz countertops. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Apartments For Rent In Spring TX Near Meredith College",
      "seo_description": "Explore The Tribute's apartments for rent in Spring TX near Meredith College. Enjoy modern amenities and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-spring-tx-near-wake-technical",
      "search_query": "Apartments For Rent In Spring TX Near Wake Technical Community College - Scott Northern Wake Campus",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Spring TX Near Wake Technical Community College",
      "h2_subtitle": "The Tribute offers convenient apartments near Wake Technical Community College with luxurious features. Find your ideal home in a vibrant and welcoming community today.",
      "page_copy": "Welcome to The Tribute, where apartments for rent in Spring TX near Wake Technical Community College - Scott Northern Wake Campus offer a perfect blend of convenience and luxury. Our community is designed with limitless possibilities, featuring elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views. Enjoy proximity to Wake Technical Community College, known for its robust College/University Transfer program and LEED®-certified buildings, while living in a serene environment surrounded by two ponds, a tropical-style swimming pool, and a 9-hole putting green.\n\nThe Tribute features a range of amenities including controlled access, a clubhouse, fitness center, and dog park, ensuring a vibrant and engaging living experience. Inside your apartment, you'll find high-speed internet access, smoke-free living, and modern kitchens with stainless steel appliances, a pantry, microwave, and quartz countertops. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Apartments For Rent In Spring TX Near Wake Technical Community College",
      "seo_description": "Explore The Tribute's apartments for rent in Spring TX near Wake Technical Community College. Enjoy modern amenities and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-spring-tx-near-rti",
      "search_query": "Apartments For Rent In Spring TX Near RTI International",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Spring TX Near RTI International",
      "h2_subtitle": "The Tribute offers convenient apartments near RTI International with luxurious features. Discover your ideal home in a vibrant and welcoming community today.",
      "page_copy": "Welcome to The Tribute, where apartments for rent in Spring TX near RTI International offer a perfect blend of convenience and luxury. Our community is designed with limitless possibilities, featuring elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views. Enjoy proximity to RTI International while living in a serene environment surrounded by two ponds, a tropical-style swimming pool, and a 9-hole putting green.\n\nThe Tribute features a range of amenities including controlled access, a clubhouse, fitness center, and dog park, ensuring a vibrant and engaging living experience. Inside your apartment, you'll find high-speed internet access, smoke-free living, and modern kitchens with stainless steel appliances, a pantry, microwave, and quartz countertops. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Apartments For Rent In Spring TX Near RTI International",
      "seo_description": "Explore The Tribute's apartments for rent in Spring TX near RTI International. Enjoy modern amenities and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-spring-tx-near-wpu",
      "search_query": "Apartments For Rent In Spring TX Near William Peace University",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Spring TX Near William Peace University",
      "h2_subtitle": "The Tribute offers convenient apartments near William Peace University with luxurious features. Find your ideal home in a vibrant and welcoming community today.",
      "page_copy": "Welcome to The Tribute, where apartments for rent in Spring TX near William Peace University offer a perfect blend of convenience and luxury. Our community is designed with limitless possibilities, featuring elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views. Enjoy proximity to William Peace University while living in a serene environment surrounded by two ponds, a tropical-style swimming pool, and a 9-hole putting green.\n\nThe Tribute features a range of amenities including controlled access, a clubhouse, fitness center, and dog park, ensuring a vibrant and engaging living experience. Inside your apartment, you'll find high-speed internet access, smoke-free living, and modern kitchens with stainless steel appliances, a pantry, microwave, and quartz countertops. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Apartments For Rent In Spring TX Near William Peace University",
      "seo_description": "Explore The Tribute's apartments for rent in Spring TX near William Peace University. Enjoy modern amenities and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-spring-tx-near-northgate",
      "search_query": "Apartments For Rent In Spring TX Near Northgate Crossing Elementary",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Spring TX Near Northgate Crossing Elementary",
      "h2_subtitle": "The Tribute offers family-friendly apartments near Northgate Crossing Elementary with luxurious features. Discover your ideal home in a vibrant and welcoming community today.",
      "page_copy": "Welcome to The Tribute, where apartments for rent in Spring TX near Northgate Crossing Elementary provide an ideal setting for families. Located just a short distance from Northgate Crossing Elementary, our community offers the perfect blend of convenience and luxury. Choose from our studio, one, and two-bedroom floor plans, each designed with elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views.\n\nThe Tribute features a range of family-friendly amenities including a tropical-style swimming pool, 9-hole putting green, and a dog park. Enjoy controlled access, a clubhouse, fitness center, and more, ensuring a vibrant and engaging living experience. Inside your apartment, you'll find high-speed internet access, smoke-free living, and modern kitchens with stainless steel appliances, a pantry, microwave, and quartz countertops. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Apartments For Rent In Spring TX Near Northgate Crossing Elementary",
      "seo_description": "Explore The Tribute's family-friendly apartments for rent in Spring TX near Northgate Crossing Elementary. Enjoy modern amenities and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-spring-tx-near-twin-creeks",
      "search_query": "Apartments For Rent In Spring TX Near Twin Creeks Middle School",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Spring TX Near Twin Creeks Middle School",
      "h2_subtitle": "The Tribute offers family-friendly apartments near Twin Creeks Middle School with luxurious features. Find your ideal home in a vibrant and welcoming community today.",
      "page_copy": "Welcome to The Tribute, where apartments for rent in Spring TX near Twin Creeks Middle School provide an ideal setting for families. Located conveniently close to Twin Creeks Middle School, part of the Spring Independent School District, our community offers the perfect blend of convenience and luxury. Choose from our studio, one, and two-bedroom floor plans, each designed with elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views.\n\nThe Tribute features a range of family-friendly amenities including a tropical-style swimming pool, 9-hole putting green, and a dog park. Enjoy controlled access, a clubhouse, fitness center, and more, ensuring a vibrant and engaging living experience. Inside your apartment, you'll find high-speed internet access, smoke-free living, and modern kitchens with stainless steel appliances, a pantry, microwave, and quartz countertops. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Apartments For Rent In Spring TX Near Twin Creeks Middle School",
      "seo_description": "Explore The Tribute's family-friendly apartments for rent in Spring TX near Twin Creeks Middle School. Enjoy modern amenities and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5647035332034560",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-spring-tx-near-edward-roberson-middle-school",
      "search_query": "Apartments For Rent In Spring TX Near Edward Roberson Middle School",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Spring TX Near Edward Roberson Middle School",
      "h2_subtitle": "The Tribute offers family-friendly apartments near Edward Roberson Middle School with luxurious features. Find your ideal home in a vibrant and welcoming community today.",
      "page_copy": "Welcome to The Tribute, where apartments for rent in Spring TX near Edward Roberson Middle School provide an ideal setting for families. Conveniently located close to Edward Roberson Middle School, our community offers the perfect blend of convenience and luxury. Choose from our studio, one, and two-bedroom floor plans, each designed with elegant crown molding, oversized windows, and private patio or balcony spaces with pristine views.\n\nThe Tribute features a range of family-friendly amenities including a tropical-style swimming pool, 9-hole putting green, and a dog park. Enjoy controlled access, a clubhouse, fitness center, and more, ensuring a vibrant and engaging living experience. Inside your apartment, you'll find high-speed internet access, smoke-free living, and modern kitchens with stainless steel appliances, a pantry, microwave, and quartz countertops. Visit us at 26325 Northgate Crossing Blvd, Spring, TX 77373, and explore our photo gallery to experience The Tribute for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex with a decorative water feature and landscaping.",
        "public_id": "019f6c13-c68b-7525-a8b8-7f0ed01b6a2d",
        "storage_key": "property/5647035332034560/019f6c13-c68b-7525-a8b8-7f0ed01b6a2d.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
      "blank_image_media": {
        "alt_text": "Exterior of a modern apartment building with large windows and balconies.",
        "public_id": "019f6c13-d1dc-77f1-b303-98347458d3e0",
        "storage_key": "property/5647035332034560/019f6c13-d1dc-77f1-b303-98347458d3e0.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Tribute | Apartments For Rent In Spring TX Near Edward Roberson Middle School",
      "seo_description": "Explore The Tribute's family-friendly apartments for rent in Spring TX near Edward Roberson Middle School. Enjoy modern amenities and a vibrant community at 26325 Northgate Crossing Blvd, Spring, TX 77373.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2604"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "3391731321"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a68\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a68\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5056169"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P9FCDCS"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "3"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://thetribute2.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "5057840441"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/er5v5ey5vny"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/517a3a49-8088-40d4-9276-884858d0eea4"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "346-788-4352"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkVzeWZOVTcwYVlMRjFEV3VhcXprRlE9PSIsInZhbHVlIjoic0p4WWlqK2hxMytrSVFRMFlQWlcrdz09IiwibWFjIjoiNjAxY2VkMWQ0NDdiZWIzN2UzNjJiNmM1NjgyYjYzZDdkNWY2M2FhNmU0MmJkZTIzNTllMzlhMTVhNmRhNWZlYyJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2604",
  "custom_repli_id": "3391731321",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a68\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a68\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "5056169",
  "custom_google_gtm_id": "GTM-P9FCDCS",
  "custom_rollout_phase": "3",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://thetribute2.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "5057840441",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/er5v5ey5vny",
  "custom_self_guided_tour_url": "https://selftournow.com/property/517a3a49-8088-40d4-9276-884858d0eea4",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "346-788-4352",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkVzeWZOVTcwYVlMRjFEV3VhcXprRlE9PSIsInZhbHVlIjoic0p4WWlqK2hxMytrSVFRMFlQWlcrdz09IiwibWFjIjoiNjAxY2VkMWQ0NDdiZWIzN2UzNjJiNmM1NjgyYjYzZDdkNWY2M2FhNmU0MmJkZTIzNTllMzlhMTVhNmRhNWZlYyJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "04d4ac54-e418-4eee-ba4d-c750a3ba463f",
  "custom_audioeye_site_hash": "e89322f9cbc1e7f44989bd7f41bf5041"
};

export const generatedAt = '2026-11-03T20:28:36.002Z';
